import React, { Component } from "react";
import moment from "moment";
import * as Cookies from "es-cookie";
import { Row, Col, Modal } from "react-bootstrap";
import { components } from "react-select";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TabSection from "./TabSection";
import SelectDropDown from "../../../../neetjee_guru/components/selectdropdown/SelectDropDown";
import MultiSelect from "react-multi-select-component";
import ProfileDateBlock from "../ProfileDateBlock";
import CardLessDataTableWithSearch from "../../data_tables/CardLessDataTableWithSearch";
import { PageShimmer } from "./Shimmer";
import { pointTooltip } from "./chartTooltip";
import ChartBoundary from "./ChartBoundary";
import { examStreamsVar, examKeysVar, examStreamsKey } from './examStreams';

const DropdownIndicator = (props) =>
    components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
            <i className="fal fa-angle-down" />
        </components.DropdownIndicator>
    );

const GET_TOP_STUDENTS = gql`
  query ($institute_id: Int!, $mobile: String, $page: Int, $limit: Int, $exam_streams: [Int], $exam_keys: [String]) {
    getTopStudents(institute_id: $institute_id, mobile: $mobile, page: $page, limit: $limit, exam_streams: $exam_streams, exam_keys: $exam_keys) {
      branch_id
      section_id
      class_id
      name
      mobile
      exam_id
      exam_names
      exam_name
      class
      section
      branch
      total_exams
      total_correct
      total_wrong
      total_questions
      avg_percentage
      avg
      total_not_answered
      total_skipped
    }
  }
`;

const examTypes = [
    { value: 0, label: "All Exams" },
    { value: 1, label: "Mock Test" },
    { value: 2, label: "Custom Exam" },
    { value: 3, label: "Scheduled Exam" },
    { value: 4, label: "Error Exam" },
    { value: 6, label: "Practice Test" },
    { value: 7, label: "Adaptive Test" },
];

const GET_STUDENT_PERFORMANCE_REPORT = gql`
  query (
    $mobile: String
    $exam_type: Int
    $exam_streams: [Int], $exam_keys: [String]
    $fromDate: String
    $toDate: String
    $target: String
  ) {
    getStudentPerformanceReport(
      mobile: $mobile
      exam_type: $exam_type
      exam_streams: $exam_streams, exam_keys: $exam_keys
      fromDate: $fromDate
      toDate: $toDate
    ) {
      snapshot(target: $target) {
        attendance
        best_subject
        weak_subject
        target
        predicted_score
        max_score
        predicted_label
        simulated_air
        risk_level
      }
      overall {
        exam_name
        total_attempt_test
        average_score
        highest_score
        lowest_score
        section_avg_score
        branch_avg_score
        avg_rank
        accuracy
      }
      scoreTrend {
        exam_name
        label
        score
        total_marks
        batch_avg
        batch_size
        topper_score
        topper_name
      }
                      examWiseResult {
                            id
                            exam_name
                            date
                            status
                            attempted
                            exam_stream
                            marks
                            accuracy
                            exam_rank
                            section_rank
                            section_total
                            mode
                            correct
                            wrong
                            skipped
                            not_answered
                            total_questions
                            correct_marks
                            negative_marks
                            total_marks
                            over_time
                            less_time
                        }
             subjectPerformance {
                            subject_id
                            subject
                            best_score
                            lowest_score
                            section_avg
                            branch_avg
                            accuracy
                        }
      chapterPerformance {
        subject_id
        subject
        chapter_id
        chapter
        attempted
        accuracy_percentage
      }
      topicPerformance {
        subject_id
        subject
        chapter_id
        chapter
        topic_id
        topic
        attempted
        accuracy_percentage
      }
      examSubjectMatrix {
        exam_paper_id
        session_id
        exam_name
        date
        subjects {
          subject_id
          subject
          attempted
          accuracy
          score
        }
      }
    }
  }
`;

const GET_BATCH_SCORE_COMPARISON = gql`
  query ($institution_id: Int, $branch_id: String, $mobile: String, $exam_paper_id: Int) {
    getBatchScoreComparison(institution_id: $institution_id, branch_id: $branch_id, mobile: $mobile, exam_paper_id: $exam_paper_id) {
      section_id
      section_name
      branch_id
      branch_name
      student_count
      subjects {
        subject_id
        subject
        avg_accuracy
        student_count
      }
      chapters {
        subject_id
        subject
        chapter_id
        chapter
        avg_accuracy
      }
      topics {
        subject_id
        subject
        chapter_id
        chapter
        topic_id
        topic
        avg_accuracy
      }
    }
  }
`;

// Full syllabus chapters for the student's subjects (all chapters, attempted or not).
const GET_STUDENT_SYLLABUS = gql`
  query ($mobile: String) {
    getStudentSyllabusChapters(mobile: $mobile) {
      subject_id
      subject
      chapter_id
      chapter
      topic_count
    }
  }
`;

// Exam history rows — same query the /student/subject/exam-history page uses.
const GET_STUDENT_EXAM_SESSIONS = gql`
  query ($mobile: String!, $exam_session_id: ID) {
    getStudentExamSessions(mobile: $mobile, exam_session_id: $exam_session_id) {
      id
      correct
      wrong
      not_answered
      total_questions
      correct_marks
      negative_marks
      total_marks
      type
      sub_type
      timestamp
      accuracy
      exam_name
      mains_2021
      exam_model_id
      speed
    }
  }
`;

// Split `total` (a whole number) across `weights` in proportion, as whole numbers that add up
// to `total` exactly (largest remainder; ties go to the larger weight). All-zero weights split
// evenly. Used to share a chapter's own counts across its topics.
const splitByShare = (total, weights = []) => {
    const n = weights.length;
    if (!n) return [];
    const t = Math.max(0, Math.round(Number(total) || 0));
    const sumW = weights.reduce((a, w) => a + (Number(w) > 0 ? Number(w) : 0), 0);
    const w = sumW > 0 ? weights.map((x) => (Number(x) > 0 ? Number(x) : 0)) : weights.map(() => 1);
    const W = sumW > 0 ? sumW : n;
    const raw = w.map((x) => (t * x) / W);
    const out = raw.map((r) => Math.floor(r));
    let rem = t - out.reduce((a, v) => a + v, 0);
    const order = raw
        .map((r, i) => ({ i, f: r - Math.floor(r) }))
        .sort((a, b) => b.f - a.f || w[b.i] - w[a.i]);
    for (let k = 0; rem > 0; k++, rem--) out[order[k % n].i] += 1;
    return out;
};

const num = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
};

// Truncate a label to N chars with an ellipsis (full text kept in the tooltip).
const trunc = (s, n = 15) => {
    const str = `${s == null ? "" : s}`;
    return str.length > n ? `${str.slice(0, n)}...` : str;
};

// Section (batch) bar colors for the comparison chart.
const BATCH_COLORS = ["#6366f1", "#22c55e", "#f59e0b", "#ef4444", "#0ea5e9", "#a855f7", "#ec4899"];

// Accuracy → heatmap cell color (red = weak → green = strong).
const heatColor = (pct) => {
    if (pct == null || isNaN(pct)) return "#f1f5f9";
    if (pct < 40) return "#ef4444";
    if (pct < 55) return "#f97316";
    if (pct < 70) return "#f59e0b";
    if (pct < 85) return "#84cc16";
    return "#22c55e";
};

// Snapshot prediction target — derive from the VIEWED student's exam_id, which is
// the authoritative signal (2 = JEE, 1 = NEET), matching resolveStudentStream.
// This avoids the earlier bug where a cookie/name substring check defaulted every
// non-"neet" student (blank/BIPC/Medical labels, or the viewer's cookie on a
// profile page) to JEE — scoring NEET students on the JEE curve. Only fall back to
// the name text when exam_id is absent.
const resolveTarget = (student) => {
    const examId = num(student?.exam_id);
    if (examId === 1) return "neet";
    if (examId === 2) return "jee";
    const exam = `${student?.exam_name || student?.stream_name || student?.exam || Cookies.get("exam_name") || ""}`.toLowerCase();
    if (exam.includes("neet") || exam.includes("bipc") || exam.includes("medical")) return "neet";
    return "jee";
};

// MPC / BIPC subject-id groups (Botany=1, Physics=2, Chemistry=3, Maths=4, Zoology=5).
const STREAM_SUBJECT_IDS = {
    MPC: new Set([2, 3, 4]),
    BIPC: new Set([1, 2, 3, 5]),
};

// Stream-DEFINING subjects (Physics/Chemistry are shared, so they don't define a stream).
// A section qualifies for a stream only if it carries one of these.
const STREAM_DEFINING_IDS = {
    MPC: new Set([4]), // Maths
    BIPC: new Set([1, 5]), // Botany, Zoology
};

// Infer a section's stream from the subjects it offers (Botany/Zoology => BIPC, Maths => MPC).
const sectionStream = (sec) => {
    const ids = new Set((sec?.subjects || []).map((s) => num(s.subject_id)));
    if (ids.has(1) || ids.has(5)) return "BIPC";
    if (ids.has(4)) return "MPC";
    return null;
};

// Resolve the student's stream from their profile text, falling back to their own subjects.
const resolveStudentStream = (student, subjectPerformance = []) => {
    // PRIMARY signal: the student's exam program (reliable even when the filtered
    // report is empty). exam_id 2 = JEE → MPC (Phy/Chem/Maths); 1 = NEET → BIPC.
    const examId = num(student?.exam_id);
    if (examId === 2) return "MPC";
    if (examId === 1) return "BIPC";
    // Secondary: text hints (BIPC/MPC/JEE/NEET) in the student's profile fields.
    const text = `${student?.exam_name || ""} ${student?.stream_name || ""} ${student?.stream || ""} ${student?.group || ""} ${student?.group_name || ""} ${student?.section_name || ""} ${student?.class_name || ""} ${student?.class || ""}`.toLowerCase();
    if (text.includes("bipc") || text.includes("neet")) return "BIPC";
    if (text.includes("mpc") || text.includes("jee")) return "MPC";
    // Last resort: infer from which subjects the student actually has data in.
    const ids = new Set(subjectPerformance.map((s) => num(s.subject_id)));
    if (ids.has(1) || ids.has(5)) return "BIPC";
    if (ids.has(4)) return "MPC";
    return null;
};

// Summary cards are aggregated across the overall rows the API returns.
const buildSummary = (overall = []) => {
    if (!overall.length) {
        return { avgScore: 0, highestScore: 0, accuracy: 0 };
    }
    const avgScore = overall.reduce((s, r) => s + num(r.average_score), 0) / overall.length;
    const highestScore = Math.max(...overall.map((r) => num(r.highest_score)));
    const accuracy = overall.reduce((s, r) => s + num(r.accuracy), 0) / overall.length;
    return {
        avgScore: Math.round(avgScore),
        highestScore: Math.round(highestScore),
        accuracy: Math.round(accuracy),
    };
};

// Parse an exam date (handles common day/month/ISO orderings) into a sortable number.
const parseExamDate = (d) => {
    if (!d) return 0;
    const m = moment(d, ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY", moment.ISO_8601], true);
    return m.isValid() ? m.valueOf() : 0;
};

// Pick the exam paper with the latest date (falls back to the last array item).
const pickLatestExam = (matrix = []) => {
    if (!matrix || !matrix.length) return null;
    return matrix.reduce((best, e) => (parseExamDate(e.date) >= parseExamDate(best.date) ? e : best), matrix[0]);
};

// Per-exam aggregates from the exam-subject matrix (score/accuracy/attempted).
const aggregateExams = (matrix = []) =>
    (matrix || []).map((m) => {
        const subs = m.subjects || [];
        // Round to 2 decimals to kill floating-point artifacts (e.g. 63.010000000000005 → 63.01).
        const round2 = (v) => Math.round(v * 100) / 100;
        const totalScore = round2(subs.reduce((s, x) => s + num(x.score), 0));
        const totalAttempted = subs.reduce((s, x) => s + num(x.attempted), 0);
        const avgAccuracy = subs.length ? Math.round(subs.reduce((s, x) => s + num(x.accuracy), 0) / subs.length) : 0;
        const avgScore = subs.length ? Math.round(totalScore / subs.length) : 0;
        const highestScore = round2(subs.reduce((mx, x) => Math.max(mx, num(x.score)), 0));
        const topSubject = subs.reduce((b, x) => (num(x.score) > num(b?.score ?? -Infinity) ? x : b), null);
        return { ...m, subjects: subs, totalScore, totalAttempted, avgAccuracy, avgScore, highestScore, topSubject };
    });

// Summary cards. Total Score = the student's HIGHEST-SCORING exam (with the "From
// <exam>" sub-line). Avg Score & Avg Accuracy = TRUE averages ACROSS ALL exams
// (mean of each exam's total / accuracy), not the best exam's per-subject figures —
// so an "Avg" card actually shows an average, not a single exam.
const buildMatrixSummary = (matrix = [], overallRaw = []) => {
    const exams = aggregateExams(matrix).filter((e) => e.subjects.length > 0);
    if (!exams.length) return { ...buildSummary(overallRaw), totalScore: 0, highestExamName: null, highestExamDate: null, examCount: 0 };
    const highestExam = exams.reduce((b, e) => (e.totalScore > (b?.totalScore ?? -Infinity) ? e : b), null);
    // Cross-exam averages: mean of each exam's TOTAL score and each exam's accuracy.
    const avgScore = Math.round(exams.reduce((s, e) => s + num(e.totalScore), 0) / exams.length);
    const avgAccuracy = Math.round(exams.reduce((s, e) => s + num(e.avgAccuracy), 0) / exams.length);
    return {
        totalScore: highestExam.totalScore,
        highestScore: highestExam.totalScore,
        avgScore,                 // mean exam total across all exams
        accuracy: avgAccuracy,    // mean accuracy across all exams
        examCount: exams.length,
        highestExamName: highestExam.exam_name || `Exam ${highestExam.exam_paper_id}`,
        highestExamDate: highestExam.date,
    };
};

// ── Selected exam + Snapshot (mirrors the college OverviewTab) ───────────────
// The report is already narrowed to the selected exam on the backend (exam_keys:
// "q" = Quick Exam, "2:1:r" = JEE Mains regular papers, ...).

// Prediction curve: NEET / JEE from the selected exam key, else the student's own.
const resolvePredictionTarget = (examKeys, student) => {
    const key = Array.isArray(examKeys) && examKeys.length ? String(examKeys[0]) : "";
    const programme = Number(key.split(",")[0].split(":")[0]);
    if (programme === 1) return "neet";
    if (programme === 2) return "jee";
    return resolveTarget(student);
};

// Score → percentile reference curves. Same tables as the college OverviewTab and
// the backend snapshot (SNAPSHOT_BENCHMARKS) — keep them in step.
const PREDICTION_BENCHMARKS = {
    neet: {
        name: "NEET", maxScore: 720, totalCandidates: 2400000, cutoffScore: 600,
        scorePercentile: [
            [720, 100], [700, 99.9], [680, 99.7], [650, 99.0], [620, 98.0],
            [600, 96.5], [550, 92.0], [500, 85.0], [450, 75.0], [400, 63.0],
            [350, 50.0], [300, 37.0], [250, 25.0], [200, 15.0], [150, 8.0],
            [100, 3.0], [0, 0],
        ],
    },
    jee: {
        name: "JEE Main", maxScore: 300, totalCandidates: 1200000, cutoffScore: 250,
        scorePercentile: [
            [300, 100], [290, 99.99], [270, 99.9], [250, 99.5], [220, 98.5],
            [200, 97.0], [180, 94.0], [160, 90.0], [140, 83.0], [120, 73.0],
            [100, 60.0], [80, 45.0], [60, 30.0], [40, 16.0], [20, 6.0], [0, 0],
        ],
    },
};

// An exam row's score: marks (= correct_marks - negative_marks on the server).
const examScore = (r) => (r.marks != null ? num(r.marks) : num(r.correct_marks) - num(r.negative_marks));

// examWiseResult can also carry PRACTICE sessions, which have no paper and so no `mode`.
// They aren't exams, so they must not count toward exam averages.
const isScheduledExam = (r) => !!r && r.mode != null;

// Exam accuracy from its own question counts: correct ÷ attempted (correct + wrong).
const examAccuracy = (r) => {
    const attempted = num(r.correct) + num(r.wrong);
    return attempted > 0 ? Math.round((num(r.correct) / attempted) * 100) : null;
};

// Summary cards from the exam results in scope (same as the college OverviewTab). Best =
// highest exam score, Avg = mean exam score, Avg Accuracy = total correct ÷ total attempted.
// Falls back to the exam-subject matrix when no exam rows are present.
const buildExamSummary = (exams = [], matrix = [], overallRaw = []) => {
    const rows = (exams || []).filter(isScheduledExam);
    if (!rows.length) return buildMatrixSummary(matrix, overallRaw);
    const best = rows.reduce((b, r) => (examScore(r) > examScore(b) ? r : b), rows[0]);
    const round2 = (v) => Math.round(v * 100) / 100;
    const avgScore = round2(rows.reduce((s, r) => s + examScore(r), 0) / rows.length);
    const correct = rows.reduce((s, r) => s + num(r.correct), 0);
    const attempted = rows.reduce((s, r) => s + num(r.correct) + num(r.wrong), 0);
    // No question counts on these rows → the per-subject matrix is the next best source.
    const accuracy = attempted > 0
        ? Math.round((correct / attempted) * 100)
        : buildMatrixSummary(matrix, overallRaw).accuracy;
    return {
        totalScore: round2(examScore(best)),
        highestScore: round2(examScore(best)),
        avgScore,
        accuracy,
        examCount: rows.length,
        highestExamName: best.exam_name || "Exam",
        highestExamDate: best.date || null,
    };
};

// Predicted score + simulated AIR: each attempt as score / total_marks (oldest first),
// a least-squares trend projected 5 exams ahead (needs ≥ 3 attempts, else the mean),
// mapped onto the target's scale and percentile curve.
const predictFromExams = (rows, target) => {
    const cfg = PREDICTION_BENCHMARKS[target] || PREDICTION_BENCHMARKS.neet;
    const ratios = [...rows]
        .filter((r) => num(r.total_marks) > 0)
        .sort((a, b) => parseExamDate(a.date) - parseExamDate(b.date) || num(a.id) - num(b.id))
        .map((r) => Math.max(0, Math.min(1, examScore(r) / num(r.total_marks))));
    if (!ratios.length) return { cfg, predictedScore: null, simulatedAIR: null };
    const n = ratios.length;
    const mx = (n - 1) / 2;
    const my = ratios.reduce((s, v) => s + v, 0) / n;
    let numer = 0, denom = 0;
    ratios.forEach((v, i) => { numer += (i - mx) * (v - my); denom += (i - mx) ** 2; });
    const slope = denom ? numer / denom : 0;
    const projected = Math.max(0, Math.min(1, n >= 3 ? slope * (n - 1 + 5) + (my - slope * mx) : my));
    const predictedScore = Math.round(projected * cfg.maxScore);
    const tbl = cfg.scorePercentile;
    let pct = 0;
    if (predictedScore >= tbl[0][0]) pct = tbl[0][1];
    else if (predictedScore <= tbl[tbl.length - 1][0]) pct = tbl[tbl.length - 1][1];
    else {
        for (let i = 0; i < tbl.length - 1; i++) {
            const [hiS, hiP] = tbl[i];
            const [loS, loP] = tbl[i + 1];
            if (predictedScore <= hiS && predictedScore >= loS) { pct = loP + ((predictedScore - loS) / (hiS - loS)) * (hiP - loP); break; }
        }
    }
    const simulatedAIR = Math.max(1, Math.round((1 - pct / 100) * cfg.totalCandidates));
    return { cfg, predictedScore, simulatedAIR };
};

// Best / weak subject by accuracy over every exam in scope: correct ÷ attempted, where a
// subject's correct count per exam is its accuracy × attempted.
const subjectStrengths = (matrix = []) => {
    const bySubject = new Map();
    (matrix || []).forEach((m) => (m.subjects || []).forEach((s) => {
        const attempted = num(s.attempted);
        if (attempted <= 0) return;
        const key = s.subject_id != null ? String(s.subject_id) : s.subject;
        const cur = bySubject.get(key) || { subject: s.subject, attempted: 0, correct: 0 };
        cur.attempted += attempted;
        cur.correct += (num(s.accuracy) / 100) * attempted;
        bySubject.set(key, cur);
    }));
    const ranked = [...bySubject.values()]
        .map((s) => ({ ...s, accuracy: (s.correct / s.attempted) * 100 }))
        .sort((a, b) => b.accuracy - a.accuracy);
    return {
        best: ranked.length ? ranked[0].subject : null,
        // One subject has no "weakest" — it would just repeat the best.
        weak: ranked.length > 1 ? ranked[ranked.length - 1].subject : null,
    };
};

// Snapshot for the selected exam: attendance from the API (it is not exam-specific),
// best/weak subject from the exam-subject matrix, prediction + AIR from the exam
// results, risk from attendance and predicted-vs-cutoff. null when nothing to show.
const buildSnapshot = (apiSnapshot, exams, matrix, target) => {
    const attendance = apiSnapshot && apiSnapshot.attendance != null ? num(apiSnapshot.attendance) : null;
    const { best, weak } = subjectStrengths(matrix);
    const { cfg, predictedScore, simulatedAIR } = predictFromExams(exams || [], target);
    let risk_level = null;
    if (attendance != null || predictedScore != null) {
        const high = (attendance != null && attendance < 70) || (predictedScore != null && predictedScore < cfg.cutoffScore * 0.7);
        const medium = (attendance != null && attendance < 85) || (predictedScore != null && predictedScore < cfg.cutoffScore * 0.85);
        risk_level = high ? "High" : medium ? "Medium" : "Low";
    }
    if (attendance == null && !best && !weak && predictedScore == null) return null;
    return {
        attendance,
        best_subject: best,
        weak_subject: weak,
        target: cfg.name,
        predicted_score: predictedScore,
        max_score: cfg.maxScore,
        predicted_label: predictedScore != null ? `${predictedScore}/${cfg.maxScore}` : null,
        simulated_air: simulatedAIR,
        risk_level,
    };
};

class OverviewTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedExamValue: { value: 0, label: "All Exams" },
            startDateCalender: moment(new Date()).subtract(1, "year").startOf("day").unix(),
            endDateCalender: moment(new Date()).endOf("day").unix(),
            overallData: [],
            scoreTrend: [],
            subjectPerformance: [],
            chapterPerformance: [], // student's own per-chapter accuracy (for the "You" heatmap row)
            topicPerformance: [], // student's own per-topic accuracy (for the chapter-click popup)
            syllabusChapters: [], // ALL chapters of the student's subjects (full syllabus)
            chapterTopicModal: null, // { subject, chapter, topics:[...] } when a chapter tile is clicked
            snapshot: null,
            examSessions: [], // exam-history rows (getStudentExamSessions)
            batchComparison: [],
            batchLoading: true, // batch comparison fetches separately (can be slow) → its own loader
            batchBranchSel: null,
            batchSectionSel: null,
            batchView: "table", // "table" | "heatmap"
            batchSubjectSel: null, // { value, label } — subject filter for the heatmap
            batchDetail: null, // clicked heatmap cell → chapter/topic detail modal
            examWiseResult: [],
            summaryModalOpen: false, // stat card → per-exam breakdown modal
            summaryMetric: null, // the clicked stat card
            summaryView: "graph", // "graph" | "table" — Exam-wise Details view
            examSubjectMatrix: [], // per-exam × per-subject attempted/accuracy/score
            topDrawerOpen: false, // Top Students side drawer
            topStudents: [],
            topLoading: false,
            topExpanded: null, // index of the expanded top-student card
            topDetailView: "table", // "table" | "graph" — expanded card view
            topPage: 1, // Top Students drawer pagination (server-side)
            topHasMore: false, // whether a next page likely exists
            topClassSel: "", // Top Students class filter ("" = all)
            topBranchSel: "", // Top Students branch filter ("" = all)
            topSectionSel: "", // Top Students section filter ("" = all)
            subjectMatrixOpen: false, // Best/Weak subject → exam-subject table modal
            subjectMatrixTitle: "", // "Best Subject" | "Weak Subject"
            subjectMatrixView: "graph", // "graph" | "table" — Exam-wise Subject Breakdown view
            subjectMatrixSubject: null, // the subject the Snapshot named (highlighted in the modal)
            selectedMatrixPaper: null, // { value: session_id, label: "exam_name · date" }
            attemptView: "table", // "graph" | "table" — Exam Performance section (MOU #4)
            attemptExamSel: { value: 0, label: "All exams" }, // exam-paper filter for that section
            attemptModeSel: "all", // "all" | "online" | "offline" — auto-hidden unless both modes exist
            examPerfModalOpen: false, // "View All" popup for Exam Performance (all filtered exams)
            examPerfModalView: "table", // "graph" | "table" — view inside the View-All popup
            showExamModal: false,
            showAttemptChart: false,
            modalTitle: "",
            modalRows: [],
            selectedExamRow: null,
            loading: false,
        };
    }

    componentDidMount() {
        const { selectedExamValue, startDateCalender, endDateCalender } = this.state;
        this.getReport(selectedExamValue?.value, startDateCalender, endDateCalender);
        this.getBatchComparison();
        this.getSyllabus();
        // Exam History table removed — actions moved into the Exam-wise Results modal.
        // this.getExamSessions();
    }

    componentDidUpdate(prevProps) {
        if (examStreamsKey(prevProps.examStreams) !== examStreamsKey(this.props.examStreams)) {
            const { selectedExamValue, startDateCalender, endDateCalender } = this.state;
            // Reset the Exam-Paper selection to "All exams" — a paper from the old
            // stream (e.g. a Mains exam) won't exist in the new stream, which would
            // filter the Exam Performance section to nothing ("No attempted exams").
            this.setState({ attemptExamSel: { value: 0, label: "All exams" } });
            this.getReport(selectedExamValue?.value, startDateCalender, endDateCalender);
            // Batch comparison must also refresh for the new stream.
            this.getBatchComparison();
            // Re-fetch top students only when the drawer is open (fetched lazily otherwise).
            if (this.state.topDrawerOpen) {
                this.fetchTopStudents(this.state.topPage || 1);
            }
        }
    }

    // Exam-history table data (mirrors the /student/subject/exam-history page query).
    getExamSessions = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STUDENT_EXAM_SESSIONS,
                variables: { mobile: `${Cookies.get("mobile") || ""}`, exam_session_id: 0 },
                  fetchPolicy: 'cache-first', // don't re-fetch on every tab switch
            });
            this.setState({ examSessions: result?.data?.getStudentExamSessions || [] });
        } catch (error) {
            console.log(error);
            this.setState({ examSessions: [] });
        }
    };

    // Redirect to the exam-result analysis page. examType defaults to the row's
    // own type; the exam-wise modal passes "schedule_exam" explicitly.
    goToExamResult = (row, examType) => {
        if (!row?.id) return;
        this.props.history.push({
            pathname: "/student/subject/exam-result",
            state: { htype: "history", sessionid: row.id, examtype: examType || row.type },
        });
    };

    // Redirect to the question-answer view for the attempt.
    goToViewQA = (row, examType) => {
        if (!row?.id) return;
        this.props.history.push({
            pathname: "/student/view-question-answer",
            state: { htype: "history", sessionid: row.id, examtype: examType || row.type },
        });
    };

    fetchBatchComparison = async (branchId, examPaperId) => {
        const result = await this.props.client.query({
            query: GET_BATCH_SCORE_COMPARISON,
            variables: {
                institution_id: parseInt(Cookies.get("institution_id")) || 0,
                branch_id: branchId,
                mobile: `${Cookies.get("mobile") || ""}`,
                exam_paper_id: examPaperId || null,
            },
              fetchPolicy: 'cache-first', // don't re-fetch on every tab switch
        });
        return result?.data?.getBatchScoreComparison || [];
    };

    // examPaperId (schedule_exam_id) → scope the batch to a single exam; null = all.
    // Full syllabus (all chapters of the student's subjects) — used as the master
    // chapter list so the heatmap/table show every chapter, attempted or not.
    getSyllabus = async () => {
        try {
            const res = await this.props.client.query({
                query: GET_STUDENT_SYLLABUS,
                variables: { mobile: `${Cookies.get("mobile") || ""}` },
                  fetchPolicy: 'cache-first', // don't re-fetch on every tab switch
            });
            this.setState({ syllabusChapters: res?.data?.getStudentSyllabusChapters || [] });
        } catch (e) {
            console.log(e);
            this.setState({ syllabusChapters: [] });
        }
    };

    getBatchComparison = async (examPaperId = null) => {
        const { student } = this.props;
        this.setState({ batchLoading: true });
        try {
            // Compare across all branches in the institution (multiple branches exist).
            let data = await this.fetchBatchComparison("", examPaperId);
            // Fallback: some backends return nothing for an empty branch_id — retry with the student's branch.
            if ((!data || data.length === 0) && student?.branch != null) {
                data = await this.fetchBatchComparison(String(student.branch), examPaperId);
            }
            this.setState({ batchComparison: data || [], batchLoading: false });
        } catch (error) {
            console.log(error);
            this.setState({ batchComparison: [], batchLoading: false });
        }
    };

    // Header Exam-Paper dropdown change: scope the whole tab (client-side) AND
    // refetch the batch comparison for that exam (backend needs its paper id).
    handleExamPaperChange = (name, value, opt) => {
        this.setState({ attemptExamSel: opt }, () => {
            this.getBatchComparison(this.selectedExamPaperId());
        });
    };

    // Map the header exam-paper selection (a session id from examWiseResult) to
    // its schedule_exam_id (exam_paper_id) via examSubjectMatrix.
    selectedExamPaperId = () => {
        const sel = this.state.attemptExamSel;
        if (!sel || !sel.value) return null;
        const ex = (this.state.examWiseResult || []).find((e) => e.id === sel.value);
        if (!ex) return null;
        const m = (this.state.examSubjectMatrix || []).find(
            (x) => x.exam_name === ex.exam_name || String(x.session_id) === String(ex.id));
        return m && m.exam_paper_id ? Number(m.exam_paper_id) : null;
    };

    selecthandleInputChange = (name, value, selectedOption) => {
        this.setState({ [name]: selectedOption }, () => {
            this.getReport(selectedOption?.value, this.state.startDateCalender, this.state.endDateCalender);
        });
    };

    applyCallback = (startDate, endDate) => {
        const start = startDate.clone().startOf("day").unix();
        const end = endDate.clone().endOf("day").unix();
        this.setState({ startDateCalender: start, endDateCalender: end }, () => {
            this.getReport(this.state.selectedExamValue?.value, start, end);
        });
    };

    getReport = async (examType, fromDate, toDate) => {
        const fromDateFinal = fromDate || this.state.startDateCalender;
        const toDateFinal = toDate || this.state.endDateCalender;
        const examTypeFinal = examType ?? this.state.selectedExamValue?.value;
        const { student } = this.props;

        this.setState({ loading: true });
        try {
            const result = await this.props.client.query({
                query: GET_STUDENT_PERFORMANCE_REPORT,
                variables: {
                    mobile: `${Cookies.get("mobile") || ""}`,
                    exam_type: examTypeFinal,
                    exam_streams: examStreamsVar(this.props.examStreams),
                    exam_keys: examKeysVar(this.props.examKeys),
                    fromDate: fromDateFinal.toString(),
                    toDate: toDateFinal.toString(),
                    target: resolvePredictionTarget(this.props.examKeys, student),
                },
                  fetchPolicy: 'cache-first', // don't re-fetch on every tab switch
            });
            const data = result?.data?.getStudentPerformanceReport;
            const examRows = data?.examWiseResult || [];
            const matrix = data?.examSubjectMatrix || [];
            this.setState({
                overallData: data?.overall || [],
                scoreTrend: data?.scoreTrend || [],
                subjectPerformance: data?.subjectPerformance || [],
                chapterPerformance: data?.chapterPerformance || [],
                topicPerformance: data?.topicPerformance || [],
                snapshot: buildSnapshot(data?.snapshot, examRows, matrix, resolvePredictionTarget(this.props.examKeys, student)),
                examWiseResult: examRows,
                examSubjectMatrix: matrix,
                // Default the modal's exam-paper selection to the last exam.
                selectedMatrixPaper: this.state.selectedMatrixPaper ||
                    (() => {
                        const latest = pickLatestExam(matrix);
                        return latest ? this.matrixPaperOption(latest) : null;
                    })(),
                loading: false,
            });
        } catch (error) {
            console.log(error);
            this.setState({ overallData: [], scoreTrend: [], subjectPerformance: [], snapshot: null, examWiseResult: [], examSubjectMatrix: [], loading: false });
        }
    };

    formatValue = (value) => (value === null || value === undefined ? "-" : value);

    // Normalise a raw exam row into the display shape used by the modal table.
    mapExamRow = (r) => ({
        id: r.id,
        exam_name: r.exam_name,
        date: r.date,
        status: r.status,
        attempted: r.attempted,
        marks: r.marks,
        accuracy: r.accuracy,
        correct: Number(r.correct) || 0,
        wrong: Number(r.wrong) || 0,
        skipped: Number(r.skipped ?? r.not_answered) || 0,
        not_answered: Number(r.not_answered) || 0,
        total_questions: Number(r.total_questions) || 0,
        correct_marks: Number(r.correct_marks) || 0,
        negative_marks: Number(r.negative_marks) || 0,
        total_marks: Number(r.total_marks) || 0,
        over_time: Number(r.over_time) || 0,
        less_time: Number(r.less_time) || 0,
    });

    // Clicking the attempt count opens a modal listing that exam's individual results.
    openExamModal = (row) => {
        const { examWiseResult } = this.state;
        // Only attempted exams are shown in the results list.
        const attemptedOnly = examWiseResult.filter((e) => e.attempted);
        const filtered = attemptedOnly.filter((e) => e.exam_name === row.exam_name);
        // Fall back to all attempted results when the row's exam name doesn't match (e.g. aggregate rows).
        const source = filtered.length ? filtered : attemptedOnly;
        this.setState({
            showExamModal: true,
            showAttemptChart: false,
            modalTitle: row.exam_name || "Exam Results",
            modalRows: source.map(this.mapExamRow),
        });
    };

    // Clickable exam name in the modal — reveals the attempt-rate chart for THAT
    // exam only (matched by exam_paper_id / id, falling back to the row index).
    examNameFormatter = (cell, row, rowIndex) => (
        <button
            type="button"
            className="btn btn-link p-0 text-left"
            style={{ fontWeight: 600, color: "#4f46e5", textDecoration: "underline" }}
            onClick={() => this.setState({ showAttemptChart: true, selectedExamRow: { ...row, __index: rowIndex } })}
        >
            {this.formatValue(cell)}
        </button>
    );

    modalColumns = [
        { dataField: "index", text: "#", formatter: (cell, row, rowIndex) => rowIndex + 1 },
        { dataField: "exam_name", text: "Exam Name", sort: true, formatter: this.examNameFormatter },
        { dataField: "date", text: "Date", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "status", text: "Status", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "marks", text: "Marks", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "accuracy", text: "Accuracy", sort: true, formatter: (cell) => (cell != null ? `${cell}%` : "-") },
        { dataField: "correct", text: "Correct", sort: true },
        { dataField: "wrong", text: "Wrong", sort: true },
        { dataField: "skipped", text: "Skipped", sort: true },
        { dataField: "not_answered", text: "Not Answered", sort: true },
        { dataField: "total_questions", text: "Total Questions", sort: true },
        { dataField: "correct_marks", text: "Correct Marks", sort: true },
        { dataField: "negative_marks", text: "Negative Marks", sort: true },
        { dataField: "total_marks", text: "Total Marks", sort: true },
        { dataField: "over_time", text: "Over Time", sort: true },
        { dataField: "less_time", text: "Less Time", sort: true },
        {
            dataField: "actions",
            text: "Actions",
            headerAlign: "right",
            align: "right",
            formatter: (cell, row) => (
                <div className="d-flex align-items-center justify-content-end" style={{ gap: 8 }}>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                        style={{ width: 32, height: 32, borderRadius: 8, padding: 0 }}
                        onClick={() => this.goToExamResult(row, "schedule_exam")}
                        title="View result analysis"
                    >
                        <i className="fas fa-chart-line" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center justify-content-center"
                        style={{ width: 32, height: 32, borderRadius: 8, padding: 0 }}
                        onClick={() => this.goToViewQA(row, "schedule_exam")}
                        title="View questions &amp; answers"
                    >
                        <i className="fas fa-external-link-alt" />
                    </button>
                </div>
            ),
        },
    ];

    closeExamModal = () =>
        this.setState({ showExamModal: false, showAttemptChart: false, modalRows: [], modalTitle: "", selectedExamRow: null });

    // Attempt-count cell rendered as a clickable link.
    attemptFormatter = (cell, row) => {
        const count = this.formatValue(cell);
        if (cell === null || cell === undefined || num(cell) === 0) return count;
        return (
            <button
                type="button"
                className="btn btn-link p-0"
                style={{ fontWeight: 600, color: "#4f46e5", textDecoration: "underline" }}
                onClick={() => this.openExamModal(row)}
            >
                {count}
            </button>
        );
    };

    articlecolumns = [
        { dataField: "index", text: "#", formatter: (cell, row, rowIndex) => rowIndex + 1 },
        { dataField: "exam_name", text: "Exam Name", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "total_attempt_test", text: "Total Attempt Test", sort: true, formatter: this.attemptFormatter },
        { dataField: "average_score", text: "Average Score", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "highest_score", text: "Highest Score", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "lowest_score", text: "Lowest Score", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "section_avg_score", text: "Section Avg Score", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "branch_avg_score", text: "Branch Avg Score", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "accuracy", text: "Accuracy Avg", sort: true, formatter: (cell) => this.formatValue(cell) },
    ];

    // Columns for the exam-history table (getStudentExamSessions).
    examHistoryColumns = [
        { dataField: "index", text: "#", formatter: (cell, row, rowIndex) => rowIndex + 1 },
        {
            dataField: "exam_name",
            text: "Exam Name",
            sort: true,
            formatter: (cell, row) => (
                <button
                    type="button"
                    className="btn btn-link p-0 text-left"
                    style={{ fontWeight: 600, color: "#2563eb", textDecoration: "none" }}
                    onClick={() => this.goToExamResult(row)}
                    title="View exam result"
                >
                    {this.formatValue(cell)}
                </button>
            ),
        },
        {
            dataField: "timestamp",
            text: "Date",
            sort: true,
            formatter: (cell) => {
                if (!cell) return "-";
                const d = moment(isNaN(cell) ? cell : new Date(parseInt(cell) * 1000));
                return d.isValid() ? d.format("DD MMM YYYY") : "-";
            },
        },
        { dataField: "total_questions", text: "Questions", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "correct", text: "Correct", sort: true, formatter: (cell) => <span style={{ color: "#16a34a", fontWeight: 600 }}>{this.formatValue(cell)}</span> },
        { dataField: "wrong", text: "Wrong", sort: true, formatter: (cell) => <span style={{ color: "#ef4444", fontWeight: 600 }}>{this.formatValue(cell)}</span> },
        { dataField: "not_answered", text: "Not Answered", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "total_marks", text: "Marks", sort: true, formatter: (cell) => <span style={{ fontWeight: 700, color: "#4f46e5" }}>{this.formatValue(cell)}</span> },
        { dataField: "accuracy", text: "Accuracy", sort: true, formatter: (cell) => (cell === null || cell === undefined ? "-" : `${cell}%`) },
        {
            dataField: "actions",
            text: "Actions",
            headerAlign: "right",
            align: "right",
            formatter: (cell, row) => (
                <div className="d-flex align-items-center justify-content-end" style={{ gap: 8 }}>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                        style={{ width: 32, height: 32, borderRadius: 8, padding: 0 }}
                        onClick={() => this.goToExamResult(row)}
                        title="View result analysis"
                    >
                        <i className="fas fa-chart-line" />
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center justify-content-center"
                        style={{ width: 32, height: 32, borderRadius: 8, padding: 0 }}
                        onClick={() => this.goToViewQA(row)}
                        title="View questions &amp; answers"
                    >
                        <i className="fas fa-external-link-alt" />
                    </button>
                </div>
            ),
        },
    ];

    renderExamHistoryTable = () => {
        const rows = this.state.examSessions || [];
        return (
            <div
                className="mt-4"
                style={{
                    borderRadius: "16px",
                    border: "1px solid #ececf6",
                    background: "#ffffff",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                    overflow: "hidden",
                }}
            >
                <div
                    className="d-flex align-items-center"
                    style={{ gap: 12, padding: "16px 20px", borderBottom: "1px solid #f1f2f5" }}
                >
                    <div
                        className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0"
                        style={{
                            width: 42,
                            height: 42,
                            borderRadius: 12,
                            background: "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)",
                            boxShadow: "0 6px 14px rgba(37,99,235,0.3)",
                        }}
                    >
                        <i className="fas fa-history" style={{ fontSize: 17 }} />
                    </div>
                    <div>
                        <h6 className="font-weight-bold text-dark mb-0" style={{ fontFamily: "'Outfit', sans-serif", fontSize: 16 }}>
                            Exam History
                        </h6>
                        <span className="text-muted" style={{ fontSize: 12.5 }}>
                            Every exam attempt with score &amp; accuracy
                        </span>
                    </div>
                </div>
                <div style={{ padding: "8px 16px 4px" }}>
                    {rows.length === 0 ? (
                        <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>No exam history available.</div>
                    ) : (
                        <CardLessDataTableWithSearch
                            parentData={rows}
                            particlecolumns={this.examHistoryColumns}
                            name="examhistory"
                        />
                    )}
                </div>
            </div>
        );
    };

    renderSummaryCards = (overall, matrix, exams) => {
        // Best Score = the highest exam score; Avg Score = mean exam score; Avg Accuracy =
        // correct ÷ attempted over every exam in scope (see buildExamSummary). Scoped to
        // the selected exam when the header exam-paper filter is on a single one.
        const { avgScore, totalScore, accuracy, highestExamName, highestExamDate, examCount } =
            buildExamSummary(exams || this.state.examWiseResult, matrix || this.state.examSubjectMatrix, overall);
        const acrossLabel = examCount ? `across ${examCount} exam${examCount === 1 ? "" : "s"}` : "across exams";
        const cards = [
            {
                label: "Best Score",
                value: totalScore,
                field: "total_score",
                icon: "fa-star",
                iconBg: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                note: "highest exam",
                noteColor: "#4f46e5",
                detail: highestExamName,   // drives the "From <exam>" sub-line
                detailDate: highestExamDate,
            },
            {
                label: "Avg Score",
                value: avgScore,
                field: "average_score",
                icon: "fa-bullseye",
                iconBg: "linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)",
                note: acrossLabel,         // true cross-exam average → "across N exams"
                noteColor: "#7c3aed",
                noteIcon: "fa-layer-group",
            },
            {
                label: "Avg Accuracy",
                value: `${accuracy}%`,
                field: "accuracy",
                icon: "fa-check-circle",
                iconBg: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                note: acrossLabel,         // true cross-exam average
                noteColor: "#16a34a",
                noteIcon: "fa-layer-group",
            },
        ];

        return (
            <Row className="mb-4">
                {cards.map((m) => (
                    <Col md={12 / cards.length} sm={6} key={m.label} className="mb-3 mb-md-0">
                        <div
                            className="sp-summary-card d-flex align-items-start justify-content-between p-3 h-100"
                            onClick={m.nonClickable ? undefined : () => this.setState({ summaryModalOpen: true, summaryMetric: m, summaryView: "graph" })}
                            title={m.hint || (m.nonClickable ? undefined : `View ${m.label} per exam`)}
                            style={{
                                borderRadius: "16px",
                                background: "#ffffff",
                                border: "1px solid #f1f2f5",
                                boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                                cursor: m.nonClickable ? "default" : "pointer",
                            }}
                        >
                            <div>
                                <span className="d-block text-muted" style={{ fontSize: "13px", fontWeight: 600 }}>
                                    {m.label}
                                </span>
                                <strong
                                    className="d-block text-dark"
                                    style={{ fontSize: "2rem", fontFamily: "'Outfit', sans-serif", lineHeight: 1.2 }}
                                >
                                    {m.value}
                                </strong>
                                {m.detail ? (
                                    <span className="d-block text-truncate" style={{ fontSize: "12px", fontWeight: 600, color: m.noteColor, maxWidth: 180 }} title={`From ${m.detail}${m.detailDate ? ` · ${m.detailDate}` : ""}`}>
                                        <i className="fas fa-trophy mr-1" style={{ fontSize: 10 }} />From {m.detail}
                                    </span>
                                ) : m.note === "predicted" ? (
                                    <span className="d-block" style={{ fontSize: "12px", fontWeight: 600, color: m.noteColor }}>
                                        <i className="fas fa-info-circle mr-1" style={{ fontSize: 10 }} />predicted
                                    </span>
                                ) : m.note ? (
                                    <span className="d-block" style={{ fontSize: "12px", fontWeight: 600, color: m.noteColor }}>
                                        <i className={`fas ${m.noteIcon || "fa-layer-group"} mr-1`} style={{ fontSize: 10 }} />{m.note}
                                    </span>
                                ) : null}
                            </div>
                            <div
                                className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0"
                                style={{
                                    width: "44px",
                                    height: "44px",
                                    borderRadius: "12px",
                                    background: m.iconBg,
                                    boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
                                }}
                            >
                                <i className={`fas ${m.icon}`} style={{ fontSize: "18px" }}></i>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        );
    };

    // Compact Exam + Date controls rendered in the TabSection header (right side).
    renderControls = () => {
        // Exam-paper options (All + each distinct attempted exam) — drives the
        // Exam Performance section. Rendered AFTER the Exam-type filter.
        const perfRows = this.buildExamPerformanceRows();
        const examPaperOptions = [
            { value: 0, label: "All exams" },
            ...perfRows.map((r) => ({ value: r.id, label: r.exam_name })),
        ];
        return (
        <div className="d-flex flex-wrap align-items-center justify-content-end" style={{ gap: "12px" }}>
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                <span className="font-weight-bold text-muted" style={{ fontSize: "13px" }}>
                    Exam
                </span>
                <div style={{ minWidth: "170px" }}>
                    <SelectDropDown
                        stateData={this.state.selectedExamValue}
                        handleChange={this.selecthandleInputChange}
                        name="selectedExamValue"
                        options={examTypes}
                        placeholderName="Exam"
                        dropdownIndicator={{ DropdownIndicator }}
                    />
                </div>
            </div>
            {examPaperOptions.length > 1 && (
                <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                    <span className="font-weight-bold text-muted" style={{ fontSize: "13px" }}>
                        Exam Paper
                    </span>
                    <div style={{ minWidth: "190px" }}>
                        <SelectDropDown
                            stateData={this.state.attemptExamSel || examPaperOptions[0]}
                            handleChange={this.handleExamPaperChange}
                            name="attemptExamSel"
                            options={examPaperOptions}
                            placeholderName="Exam Paper"
                            dropdownIndicator={{ DropdownIndicator }}
                        />
                    </div>
                </div>
            )}
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                <span className="font-weight-bold text-muted" style={{ fontSize: "13px" }}>
                    Date
                </span>
                <ProfileDateBlock
                    applyCallback={this.applyCallback}
                    start={moment.unix(this.state.startDateCalender)}
                    end={moment.unix(this.state.endDateCalender)}
                />
            </div>
            <button type="button" className="sp-ask-doubt-btn" onClick={this.openTopStudents}>
                <i className="fas fa-trophy mr-2" /> Top 10 Students
            </button>
        </div>
        );
    };

    // Fetch top students from the college backend (separate endpoint) and open the drawer.
    TOP_PAGE_SIZE = 10;

    openTopStudents = () => {
        this.setState({ topDrawerOpen: true, topPage: 1, topExpanded: null, topClassSel: "", topBranchSel: "", topSectionSel: "" });
        this.fetchTopStudents(1);
    };

    fetchTopStudents = async (page = 1) => {
        this.setState({ topLoading: true, topExpanded: null });
        try {
            const result = await this.props.client.query({
                query: GET_TOP_STUDENTS,
                variables: {
                    institute_id: parseInt(Cookies.get("institution_id") || Cookies.get("institutionid")) || 0,
                    mobile: `${Cookies.get("mobile") || ""}`,
                    exam_streams: examStreamsVar(this.props.examStreams),
                    exam_keys: examKeysVar(this.props.examKeys),
                    page,
                    limit: this.TOP_PAGE_SIZE,
                },
                  fetchPolicy: 'cache-first', // don't re-fetch on every tab switch
            });
            const list = result?.data?.getTopStudents || [];
            this.setState({ topStudents: list, topLoading: false, topPage: page, topHasMore: list.length >= this.TOP_PAGE_SIZE });
        } catch (e) {
            console.log(e);
            this.setState({ topStudents: [], topLoading: false, topHasMore: false });
        }
    };

    // Expanded top-student card — previous exams correct/wrong totals as table + graph.
    renderTopStudentDetail = (s) => {
        const view = this.state.topDetailView || "table";
        const correct = num(s.total_correct);
        const wrong = num(s.total_wrong);
        // const notAnswered = num(s.total_not_answered);
        const skipped = num(s.total_skipped);
        const totalQ = num(s.total_questions) || correct + wrong;
        const unattempted = Math.max(0, totalQ - correct - wrong);
        const exams = `${s.exam_names || ""}`.split(",").map((e) => e.trim()).filter(Boolean);
        const accuracy = totalQ > 0 ? Math.round((correct / totalQ) * 1000) / 10 : 0;

        const setView = (v) => (e) => { e.stopPropagation(); this.setState({ topDetailView: v }); };

        const donut = {
            chart: { type: "pie", backgroundColor: "transparent", height: 210 },
            title: { text: "" },
            credits: { enabled: false },
            tooltip: { pointFormat: "<b>{point.y}</b> ({point.percentage:.1f}%)" },
            plotOptions: {
                pie: {
                    innerSize: "62%",
                    dataLabels: { enabled: true, format: "{point.name}: {point.y}", style: { fontSize: "11px", fontWeight: "600", color: "#334155" }, distance: 8 },
                },
            },
            series: [{
                name: "Questions",
                data: [
                    { name: "Correct", y: correct, color: "#16a34a" },
                    { name: "Wrong", y: wrong, color: "#ef4444" },
                    ...(unattempted > 0 ? [{ name: "Unattempted", y: unattempted, color: "#cbd5e1" }] : []),
                ],
            }],
        };

        return (
            <div className="px-3 pb-3" style={{ borderTop: "1px dashed #e2e8f0" }} onClick={(e) => e.stopPropagation()}>
                <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
                    <span className="font-weight-bold text-dark" style={{ fontSize: 12.5 }}>Performance Summary — Correct / Wrong</span>
                    <div className="sp-segment d-inline-flex" style={{ fontSize: 11 }}>
                        <button type="button" className={`sp-segment-btn ${view === "table" ? "active" : ""}`} onClick={setView("table")}><i className="fas fa-table mr-1" />Table</button>
                        <button type="button" className={`sp-segment-btn ${view === "graph" ? "active" : ""}`} onClick={setView("graph")}><i className="fas fa-chart-pie mr-1" />Graph</button>
                    </div>
                </div>

                {view === "table" ? (
                    <table className="table table-sm mb-2" style={{ fontSize: 12.5 }}>
                        <tbody>
                            <tr><td className="text-muted">Total Exams</td><td className="text-right font-weight-bold text-dark">{num(s.total_exams)}</td></tr>
                            <tr><td className="text-muted">Correct Answers</td><td className="text-right font-weight-bold" style={{ color: "#16a34a" }}>{correct}</td></tr>
                            <tr><td className="text-muted">Wrong Answers</td><td className="text-right font-weight-bold" style={{ color: "#ef4444" }}>{wrong}</td></tr>
                            {/* <tr><td className="text-muted">Not Answered</td><td className="text-right font-weight-bold" style={{ color: "#f59e0b" }}>{notAnswered}</td></tr> */}
                            <tr><td className="text-muted">Skipped</td><td className="text-right font-weight-bold" style={{ color: "#94a3b8" }}>{skipped}</td></tr>
                            <tr><td className="text-muted">Total Questions</td><td className="text-right font-weight-bold text-dark">{totalQ}</td></tr>
                            <tr><td className="text-muted">Accuracy</td><td className="text-right font-weight-bold" style={{ color: "#6366f1" }}>{accuracy}%</td></tr>
                            <tr><td className="text-muted">Average Score</td><td className="text-right font-weight-bold text-dark">{s.avg != null ? s.avg : `${num(s.avg_percentage)}%`}</td></tr>
                        </tbody>
                    </table>
                ) : (
                    <HighchartsReact highcharts={Highcharts} options={donut} />
                )}

                {exams.length > 0 ? (
                    <div className="mt-2">
                        <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.3, textTransform: "uppercase" }}>Exams Attempted</div>
                        <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                            {exams.map((e, k) => (
                                <span key={k} style={{ fontSize: 11, background: "#f1f5f9", color: "#475569", borderRadius: 8, padding: "3px 8px" }}>{e}</span>
                            ))}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    // Sections of the student's own stream + branch, taken from the batch comparison data.
    // Shared between the Batch-wise chart and the Top 10 Students section filter so both
    // list exactly the same sections (all sections in the batch, not just those in the top 10).
    getScopedBatchSections = () => {
        const sections = this.state.batchComparison || [];
        const stream = resolveStudentStream(this.props.student, this.state.subjectPerformance);
        const definingIds = stream ? STREAM_DEFINING_IDS[stream] : null;
        const sectionInStream = (sec) =>
            !definingIds || (sec.subjects || []).some((s) => definingIds.has(num(s.subject_id)));
        const filteredSections = definingIds ? sections.filter(sectionInStream) : sections;
        const streamMatched = !definingIds || filteredSections.length > 0;
        const streamSections = streamMatched ? filteredSections : sections;

        const stu = this.props.student || {};
        const stuBranchKey = stu.branch_id != null ? String(stu.branch_id) : (stu.branch_name ? String(stu.branch_name) : null);
        const branchKey = (sec) => String(sec.branch_id != null ? sec.branch_id : sec.branch_name);
        const branchesInData = new Set(streamSections.map(branchKey));
        // Scope to the student's own branch when it exists in the data; otherwise show all.
        return stuBranchKey && branchesInData.has(stuBranchKey)
            ? streamSections.filter((sec) => branchKey(sec) === stuBranchKey)
            : streamSections;
    };

    renderTopStudentsDrawer = () => {
        const { topDrawerOpen, topStudents, topLoading, topPage, topHasMore, topSectionSel } = this.state;
        const curPage = topPage;

        // Distinct filter options derived from the loaded students.
        const distinct = (key) => Array.from(new Set(topStudents.map((s) => `${s[key] ?? ""}`.trim()).filter(Boolean))).sort();
        // Section options come from the SAME source as the Batch-wise comparison dropdown
        // (all sections of the student's stream + branch), so every section is listed —
        // not just the sections that happen to have a student in the top 10 (e.g. NS 2).
        const batchSectionNames = this.getScopedBatchSections()
            .map((sec) => `${sec.section_name ?? ""}`.trim())
            .filter(Boolean);
        const sectionOpts = Array.from(new Set([...batchSectionNames, ...distinct("section")])).sort();

        // Class & Branch are locked to the logged-in student's own (from cookies); only Section filters.
        const lockClassRaw = `${Cookies.get("class_id") || Cookies.get("classid") || ""}`.trim();
        const lockClassLabel = lockClassRaw === "1" ? "XI" : lockClassRaw === "2" ? "XII" : lockClassRaw;
        const lockBranchLabel = `${Cookies.get("branch_name") || ""}`.trim();

        // Class/branch are already scoped by the query; only the Section selection filters client-side.
        const matches = (s) =>
            (!topSectionSel || `${s.section ?? ""}`.trim() === topSectionSel);
        const pageItems = topStudents.filter(matches);

        const goPage = (p) => this.fetchTopStudents(p);
        const selStyle = { fontSize: 12, padding: "5px 8px", borderRadius: 8, border: "1px solid #e2e8f0", color: "#475569", background: "#fff", flex: 1, minWidth: 0 };
        const lockedSelStyle = { ...selStyle, background: "#f1f5f9", color: "#94a3b8", cursor: "not-allowed" };
        return (
            <>
                <div className={`sp-drawer-overlay ${topDrawerOpen ? "open" : ""}`} onClick={() => this.setState({ topDrawerOpen: false })} />
                <div className={`sp-doubt-drawer ${topDrawerOpen ? "open" : ""}`}>
                    <div className="sp-drawer-header">
                        <h5 className="font-weight-bold text-dark mb-0"><i className="fas fa-trophy mr-2" style={{ color: "#f59e0b" }} />Top 10 Students</h5>
                        <button type="button" className="sp-drawer-close" onClick={() => this.setState({ topDrawerOpen: false })}>&times;</button>
                    </div>
                    <div className="sp-drawer-body">
                        {!topLoading && topStudents.length > 0 ? (
                            <div className="d-flex align-items-center mb-3" style={{ gap: 8 }}>
                                {lockClassLabel ? (
                                    <select value={lockClassLabel} disabled style={lockedSelStyle}>
                                        <option value={lockClassLabel}>Class {lockClassLabel}</option>
                                    </select>
                                ) : null}
                                {lockBranchLabel ? (
                                    <select value={lockBranchLabel} disabled style={lockedSelStyle}>
                                        <option value={lockBranchLabel}>{lockBranchLabel}</option>
                                    </select>
                                ) : null}
                                <select value={topSectionSel} onChange={(e) => this.setState({ topSectionSel: e.target.value, topExpanded: null })} style={selStyle}>
                                    <option value="">All Sections</option>
                                    {sectionOpts.map((sc) => <option key={sc} value={sc}>{sc}</option>)}
                                </select>
                            </div>
                        ) : null}
                        {topLoading ? (
                            <div className="text-center text-muted py-5"><i className="fas fa-circle-notch fa-spin mr-2" />Loading…</div>
                        ) : topStudents.length > 0 && pageItems.length === 0 ? (
                            <div className="text-center text-muted py-5" style={{ fontSize: 14 }}>No students match the selected filters.</div>
                        ) : topStudents.length > 0 ? (
                            (() => {
                                const myMobile = `${Cookies.get("mobile") || ""}`.trim();
                                return pageItems.map((s, idx) => {
                                    const key = `${s.mobile ?? idx}`;
                                    const isMe = myMobile && `${s.mobile || ""}`.trim() === myMobile;
                                    const isOpen = this.state.topExpanded === key;
                                    const meta = [s.class && `Class ${s.class}`, s.section, s.branch].filter(Boolean).join(" · ");
                                    return (
                                        <div key={key} className="mb-3" style={{ borderRadius: 14, border: isMe ? "1.5px solid #6366f1" : isOpen ? "1.5px solid #c7d2fe" : "1px solid #f1f2f5", background: isMe ? "linear-gradient(180deg,#eef2ff 0%,#f5f7ff 100%)" : "#fff", boxShadow: isMe ? "0 6px 18px rgba(99,102,241,0.18)" : "0 4px 12px rgba(17,24,39,0.04)", overflow: "hidden" }}>
                                            <div className="d-flex align-items-center p-3" style={{ gap: 12, cursor: "pointer" }}
                                                onClick={() => this.setState({ topExpanded: isOpen ? null : key })}>
                                                <div className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0 font-weight-bold"
                                                    style={{ width: 40, height: 40, borderRadius: 11, background: "#6366f1", fontSize: 15 }}>
                                                    {`${s.name || "-"}`.trim().charAt(0).toUpperCase() || "-"}
                                                </div>
                                                <div style={{ minWidth: 0, flex: 1 }}>
                                                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                        <div className="font-weight-bold text-dark text-truncate" style={{ fontSize: 14 }}>{s.name || "-"}</div>
                                                        {isMe ? <span className="flex-shrink-0" style={{ fontSize: 10, fontWeight: 700, color: "#fff", background: "#6366f1", borderRadius: 20, padding: "2px 8px", letterSpacing: 0.3 }}>YOU</span> : null}
                                                    </div>
                                                    <div className="text-muted d-flex align-items-center flex-wrap" style={{ fontSize: 12, gap: 10 }}>
                                                        {meta ? <span><i className="fas fa-graduation-cap mr-1" />{meta}</span> : null}
                                                        {s.avg != null ? <span style={{ color: "#16a34a", fontWeight: 600 }}><i className="fas fa-bullseye mr-1" />{s.avg}</span> : null}
                                                        {s.total_exams != null ? <span><i className="fas fa-file-alt mr-1" />{s.total_exams} exams</span> : null}
                                                    </div>
                                                </div>
                                                <i className={`fas fa-chevron-${isOpen ? "up" : "down"} flex-shrink-0`} style={{ color: "#94a3b8", fontSize: 12 }} />
                                            </div>
                                            {isOpen ? this.renderTopStudentDetail(s) : null}
                                        </div>
                                    );
                                });
                            })()
                        ) : (
                            <div className="text-center text-muted py-5" style={{ fontSize: 14 }}>No top students available.</div>
                        )}

                        {!topLoading && (curPage > 1 || topHasMore) ? (
                            <div className="d-flex align-items-center justify-content-between mt-2 pt-2" style={{ borderTop: "1px solid #f1f2f5" }}>
                                <button type="button" disabled={curPage <= 1} onClick={() => goPage(curPage - 1)}
                                    style={{ fontSize: 12, fontWeight: 600, color: curPage <= 1 ? "#cbd5e1" : "#6366f1", background: "transparent", border: "none", cursor: curPage <= 1 ? "default" : "pointer" }}>
                                    <i className="fas fa-chevron-left mr-1" />Prev
                                </button>
                                <span className="text-muted font-weight-bold" style={{ fontSize: 12 }}>Page {curPage}</span>
                                <button type="button" disabled={!topHasMore} onClick={() => goPage(curPage + 1)}
                                    style={{ fontSize: 12, fontWeight: 600, color: !topHasMore ? "#cbd5e1" : "#6366f1", background: "transparent", border: "none", cursor: !topHasMore ? "default" : "pointer" }}>
                                    Next<i className="fas fa-chevron-right ml-1" />
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    };

    // Score Trend vs Batch — PER EXAM: the student's total score vs the average
    // total score of their class+branch batchmates on each exam. Always across
    // all exams (a trend needs multiple points); the selected exam is highlighted.
    renderTrendChart = (_overallIgnored, highlightExam) => {
        const trend = this.state.scoreTrend || [];
        const categories = trend.map((r) => r.exam_name || r.label || "-");
        const hlName = highlightExam && highlightExam.exam_name;
        // Each point carries the exam's max marks so the tooltip can show "X / max".
        const scoreData = trend.map((r) => {
            const p = { y: num(r.score), outOf: num(r.total_marks) };
            if (hlName && r.exam_name === hlName) p.color = "#4f46e5";
            return p;
        });
        const batchData = trend.map((r) => (r.batch_avg != null ? { y: num(r.batch_avg), outOf: num(r.total_marks) } : null));
        const topperData = trend.map((r) => (r.topper_score != null ? { y: num(r.topper_score), outOf: num(r.total_marks), topperName: r.topper_name || "" } : null));

        const options = {
            chart: { type: "column", backgroundColor: "transparent", height: 320 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories,
                lineColor: "#e2e8f0",
                labels: { style: { color: "#64748b", fontWeight: "600", fontSize: "11px" }, rotation: categories.length > 4 ? -35 : 0 },
            },
            yAxis: {
                min: 0,
                title: { text: "Score", style: { color: "#94a3b8", fontSize: "11px" } },
                gridLineColor: "#eef2f6",
                labels: { style: { color: "#64748b" } },
            },
            tooltip: {
                enabled: true, shared: false, useHTML: true,
                backgroundColor: "#fff", borderColor: "#e2e8f0", borderRadius: 10, shadow: true, padding: 0,
                formatter: function () {
                    const color = this.series.color;
                    const isTopper = this.series.name === "Topper";
                    const who = isTopper && this.point.topperName
                        ? `<div style="font-size:11px;color:#94a3b8">${this.point.topperName}</div>` : "";
                    // Show "score / max" using the exam's total marks when known.
                    const outOf = this.point && this.point.outOf ? this.point.outOf : null;
                    const valStr = outOf
                        ? `${this.y}<span style="color:#94a3b8;font-weight:600;font-size:12px"> / ${outOf}</span>`
                        : `${this.y}`;
                    return (
                        `<div style="min-width:120px;padding:8px 12px">` +
                        `<div style="font-size:11px;color:#94a3b8;margin-bottom:3px">${this.key || ""}</div>` +
                        `<div style="display:flex;align-items:center;gap:7px">` +
                        `<span style="width:9px;height:9px;border-radius:50%;background:${color};display:inline-block"></span>` +
                        `<span style="font-size:12.5px;font-weight:700;color:#334155">${this.series.name}</span></div>` +
                        who +
                        `<div style="margin-top:3px;font-size:15px;font-weight:700;color:${color}">${valStr}</div>` +
                        `</div>`
                    );
                },
            },
            legend: { align: "center", verticalAlign: "top", itemStyle: { fontSize: "12px", fontWeight: "600" } },
            plotOptions: {
                column: {
                    borderRadius: 4,
                    groupPadding: 0.12,
                    pointPadding: 0.04,
                    dataLabels: {
                        enabled: true,
                        // allowOverlap skips Highcharts' hideOverlappingLabels pass,
                        // which crashes (labelrank) when some series are hidden/null.
                        allowOverlap: true,
                        formatter: function () { return this.y != null && this.y > 0 ? this.y : null; },
                        style: { fontWeight: "700", fontSize: "10px", color: "#475569", textOutline: "none" },
                    },
                },
                spline: { dataLabels: { enabled: false }, states: { hover: { lineWidthPlus: 1 } } },
            },
            series: [
                {
                    // You — the student's score per exam (highlighted).
                    name: "You",
                    data: scoreData,
                    color: "#6366f1",
                },
                {
                    // Batch Average — a benchmark LINE across the bars, not a bar.
                    name: "Batch Average",
                    type: "spline",
                    data: batchData,
                    color: "#64748b",
                    lineWidth: 2.5,
                    dashStyle: "ShortDash",
                    marker: { enabled: true, radius: 3, symbol: "circle" },
                    dataLabels: { enabled: false },
                    // Show whenever batch data exists (points are {y, outOf} objects,
                    // so check v.y — not the object itself).
                    visible: batchData.some((v) => v != null && num(v.y) > 0),
                },
                {
                    // Topper — highest scorer on each exam.
                    name: "Topper",
                    data: topperData,
                    color: "#16a34a",
                    visible: topperData.some((v) => v != null && num(v.y) > 0),
                },
            ],
        };

        // How many batchmates the average spans (for the subtitle).
        const batchSize = trend.reduce((mx, r) => Math.max(mx, num(r.batch_size)), 0);

        return (
            <div
                className="p-3 mt-4"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Score Trend vs Batch
                </h6>
                <span className="text-muted d-block mb-3" style={{ fontSize: "11.5px" }}>
                    Your total score per exam vs your class &amp; branch <b style={{ color: "#94a3b8" }}>average</b> and the <b style={{ color: "#16a34a" }}>topper</b>
                    {batchSize > 0 ? ` (${batchSize} batchmates)` : ""}
                </span>
                {trend.length > 0 ? (
                    // Horizontal scroll when there are many exams: give each exam a
                    // fixed slot (~90px for its 3 grouped bars) so bars never squish;
                    // the container scrolls when total width exceeds the panel.
                    (() => {
                        const minWidth = Math.max(trend.length * 90, 320);
                        return (
                            <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                                <div style={{ minWidth }}>
                                    <HighchartsReact highcharts={Highcharts} options={options} />
                                </div>
                            </div>
                        );
                    })()
                ) : (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No score trend available.
                    </div>
                )}
            </div>
        );
    };


    // Subject-wise Performance — best/lowest score vs branch & section averages per subject.
    renderSubjectWisePerformance = (subjectPerformance = []) => {
        const options = {
            chart: {
                type: "bar",
                backgroundColor: "#f5f7fa",
                borderRadius: 10,
                spacingLeft: 20,
                height: 320,
                scrollablePlotArea: {
                    minWidth: subjectPerformance?.length > 10 ? subjectPerformance.length * 80 : null,
                    scrollPositionX: 0,
                },
            },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories: subjectPerformance.map((item) => item.subject),
                scrollbar: { enabled: true },
                labels: { style: { fontWeight: "600", color: "#000" } },
            },
            yAxis: {
                title: { text: "Score" },
                tickInterval: 5,
            },
            tooltip: { enabled: true },
            plotOptions: {
                bar: { dataLabels: { enabled: true } },
                series: { borderRadius: 6, pointPadding: 0.1, groupPadding: 0.2 },
            },
            legend: {
                layout: "vertical",
                align: "right",
                verticalAlign: "top",
                x: -40,
                y: 80,
            },
            series: [
                { name: "Best Score", data: subjectPerformance.map((i) => num(i.best_score)), color: "#1f4e79" },
                { name: "Lowest Score", data: subjectPerformance.map((i) => num(i.lowest_score)), color: "#2ecc71" },
                { name: "Branch Avg", data: subjectPerformance.map((i) => num(i.branch_avg)), color: "#007bff" },
                { name: "Section Avg", data: subjectPerformance.map((i) => num(i.section_avg)), color: "#e74c3c" },
            ],
            exporting: { enabled: true },
        };

        return (
            <div
                className="p-3 mt-4"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Subject-wise Performance
                </h6>
                {subjectPerformance.length > 0 ? (
                    <HighchartsReact highcharts={Highcharts} options={options} />
                ) : (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No subject-wise performance available.
                    </div>
                )}
            </div>
        );
    };

    // Modal listing individual exam attempts (examWiseResult) for the clicked row.
    // Attempt rate tracking — questions attempted vs. skipped in each test.
    renderAttemptChart = (rows) => {
        const categories = rows.map((r, i) => r.exam_name || r.date || `Test ${i + 1}`);
        const attempted = rows.map((r) => num(r.correct) + num(r.wrong));
        const skipped = rows.map((r) => num(r.not_answered));
        const options = {
            chart: { type: "column", backgroundColor: "transparent", height: 320 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories,
                lineColor: "#e2e8f0",
                labels: { style: { color: "#64748b", fontWeight: "600" } },
            },
            yAxis: {
                min: 0,
                title: { text: "Questions" },
                gridLineColor: "#eef2f6",
                labels: { style: { color: "#64748b" } },
            },
            tooltip: { shared: false, enabled: true },
            legend: { align: "center", verticalAlign: "top" },
            plotOptions: { column: { borderRadius: 4, groupPadding: 0.15, dataLabels: { enabled: true, style: { fontWeight: "700", color: "#334155" } } } },
            series: [
                { name: "Attempted", data: attempted, color: "#22c55e" },
                { name: "Skipped", data: skipped, color: "#ef4444" },
            ],
        };
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-link p-0 mb-3"
                    style={{ fontWeight: 600, color: "#4f46e5" }}
                    onClick={() => this.setState({ showAttemptChart: false, selectedExamRow: null })}
                >
                    <i className="fas fa-angle-left mr-1" /> Back to results
                </button>
                <h6 className="font-weight-bold text-dark mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Attempt Rate Tracking — questions attempted vs. skipped in each test
                </h6>
                {rows.length > 0 ? (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        containerProps={{ style: { width: "100%" } }}
                    />
                ) : (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No attempt data available.
                    </div>
                )}
            </div>
        );
    };

    renderExamModal = () => {
        const { showExamModal, showAttemptChart, modalTitle, modalRows, selectedExamRow } = this.state;
        // Chart only the selected exam — match by exam_paper_id / id, else the captured index.
        let chartRows = modalRows;
        if (selectedExamRow) {
            const matched = modalRows.filter((r) =>
                selectedExamRow.exam_paper_id != null
                    ? r.exam_paper_id === selectedExamRow.exam_paper_id
                    : selectedExamRow.id != null
                        ? r.id === selectedExamRow.id
                        : false
            );
            chartRows = matched.length
                ? matched
                : (modalRows[selectedExamRow.__index] ? [modalRows[selectedExamRow.__index]] : [selectedExamRow]);
        }
        return (
            <Modal show={showExamModal} onHide={this.closeExamModal} size={showAttemptChart ? undefined : "xl"}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontFamily: "'Outfit', sans-serif", fontSize: "18px" }}>
                        {modalTitle} — {showAttemptChart ? "Attempt Rate" : "Exam-wise Results"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalRows.length > 0 ? (
                        showAttemptChart ? (
                            this.renderAttemptChart(chartRows)
                        ) : (
                            <CardLessDataTableWithSearch
                                parentData={modalRows}
                                particlecolumns={this.modalColumns}
                                name="report"
                            />
                        )
                    ) : (
                        <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                            No exam-wise results available.
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    // Snapshot card — quick at-a-glance summary (attendance, subjects, prediction, risk).
    renderSnapshot = (snapshot) => {
        const s = snapshot || {};
        const targetLabel = (s.target || "").toUpperCase();
        const rows = [
            { label: "Attendance", value: s.attendance != null ? `${s.attendance}%` : "-", color: "#16a34a" },
            { label: "Best Subject", value: this.formatValue(s.best_subject), color: "#1e293b", clickable: true },
            { label: "Weak Subject", value: this.formatValue(s.weak_subject), color: "#dc2626", clickable: true },
            {
                label: `Predicted ${targetLabel || "Score"}`,
                value:
                    s.predicted_score != null
                        ? `${s.predicted_score}${s.max_score != null ? `/${s.max_score}` : ""}`
                        : "-",
                color: "#1e293b",
            },
            {
                label: "Simulated AIR",
                value: s.simulated_air != null ? Number(s.simulated_air).toLocaleString("en-IN") : "-",
                color: "#1e293b",
            },
            { label: "Risk Level", value: this.formatValue(s.risk_level), color: this.riskColor(s.risk_level) },
        ];
        return (
            <div
                className="p-4 mt-4 h-100"
                style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}
            >
                <h6 className="font-weight-bold text-dark mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
                    Snapshot
                </h6>
                {snapshot ? (
                    rows.map((r, i) => (
                        <div
                            key={r.label}
                            className="d-flex align-items-center justify-content-between py-2"
                            style={{
                                borderBottom: i < rows.length - 1 ? "1px solid #f1f2f5" : "none",
                                cursor: r.clickable ? "pointer" : "default",
                            }}
                            onClick={r.clickable ? () => this.openSubjectMatrix(r.label, r.value !== "-" ? r.value : null) : undefined}
                            title={r.clickable ? "View exam-wise subject breakdown" : undefined}
                        >
                            <span className="text-muted" style={{ fontSize: "14px" }}>
                                {r.label}
                                {r.clickable ? <i className="fas fa-table ml-2" style={{ fontSize: 11, color: "#7c3aed" }} /> : null}
                            </span>
                            <span className="font-weight-bold d-inline-flex align-items-center" style={{ fontSize: "15px", color: r.color, gap: 6 }}>
                                {r.value}
                                {r.clickable ? <i className="fas fa-chevron-right" style={{ fontSize: 10, color: "#cbd5e1" }} /> : null}
                            </span>
                        </div>
                    ))
                ) : (
                    <div className="text-center text-muted py-4" style={{ fontSize: "14px" }}>
                        No snapshot available.
                    </div>
                )}
            </div>
        );
    };

    // Stat card → detailed exam-paper breakdown (from examSubjectMatrix): per exam,
    // which subjects, their score/accuracy/attempted, aggregates, best exam highlighted.
    renderSummaryModal = () => {
        const { summaryModalOpen, summaryMetric, examSubjectMatrix, summaryView, examWiseResult, overallData } = this.state;
        if (!summaryModalOpen || !summaryMetric) return null;

        // The same exams the cards count: one row per scheduled exam in examWiseResult
        // (practice excluded, re-submissions already collapsed by the server). Subject
        // detail comes from the matching examSubjectMatrix session; Total Score and Avg
        // Accuracy come from the exam's own result so they agree with the cards. An exam
        // with no question-level data is still listed, with no subject cells.
        const examRows = (examWiseResult || []).filter(isScheduledExam);
        const matrixBySession = new Map((examSubjectMatrix || []).map((m) => [String(m.session_id), m]));
        const anyMatched = examRows.some((r) => matrixBySession.has(String(r.id)));
        const round2 = (v) => Math.round(v * 100) / 100;
        const exams = anyMatched
            ? aggregateExams(examRows.map((r) => matrixBySession.get(String(r.id))
                || { exam_paper_id: `s${r.id}`, session_id: r.id, exam_name: r.exam_name, date: r.date, subjects: [] }))
                .map((e) => {
                    const r = examRows.find((x) => String(x.id) === String(e.session_id));
                    if (!r) return e;
                    const acc = examAccuracy(r);
                    return { ...e, totalScore: round2(examScore(r)), avgAccuracy: acc != null ? acc : e.avgAccuracy };
                })
            // Ids don't line up (older backend) → the matrix as before.
            : aggregateExams(examSubjectMatrix);

        // Rank exams by the clicked metric so the best one floats to the top with a badge.
        const field = summaryMetric.field;
        const sortVal = (e) =>
            field === "accuracy" ? e.avgAccuracy : field === "average_score" ? e.avgScore : e.totalScore;
        const sorted = [...exams].sort((a, b) => sortVal(b) - sortVal(a));
        const topId = sorted.length ? sorted[0].exam_paper_id : null;

        // Rank per exam — matched precisely by the exam's session/paper id first
        // (name matching collapses same-named exams onto one rank), then by name.
        const rankById = {};
        const rankByName = {};
        (examWiseResult || []).forEach((r) => {
            if (r.exam_rank == null) return;
            if (r.id != null) rankById[String(r.id)] = num(r.exam_rank);
            const k = String(r.exam_name || "").trim();
            if (k && rankByName[k] == null) rankByName[k] = num(r.exam_rank);
        });
        (overallData || []).forEach((r) => {
            const k = String(r.exam_name || "").trim();
            if (k && rankByName[k] == null && r.avg_rank != null) rankByName[k] = num(r.avg_rank);
        });
        const rankOf = (e) => {
            if (e.session_id != null && rankById[String(e.session_id)] != null) return rankById[String(e.session_id)];
            if (e.exam_paper_id != null && rankById[String(e.exam_paper_id)] != null) return rankById[String(e.exam_paper_id)];
            const k = String(e.exam_name || "").trim();
            return rankByName[k] != null ? rankByName[k] : null;
        };

        // The clicked metric's value per exam (bar), plus rank (line). Avg Score is the mean
        // of each exam's total, so its bars are the exam totals it averages.
        const metricValueOf = (e) =>
            field === "accuracy" ? e.avgAccuracy : field === "average_score" ? e.totalScore : field === "highest_score" ? e.highestScore : e.totalScore;
        const metricSuffix = field === "accuracy" ? "%" : "";
        const metricColor = summaryMetric.noteColor || "#6366f1";

        // Graph: chronological across exams. Total Score card → combined bar + line
        // view (Total Score & Avg Score bars + Avg Accuracy line); others → single metric.
        const byDate = [...exams].sort((a, b) => parseExamDate(a.date) - parseExamDate(b.date));
        const isTotalView = field === "total_score";

        // Highlight for the clicked card: Best Score → its exam's column; Avg Score → the
        // Total Score row; Avg Accuracy → the Avg Accuracy row. Each card has its own tint.
        const HIGHLIGHT = {
            total_score: { bg: "#e0e7ff", text: "#3730a3" },
            average_score: { bg: "#ede9fe", text: "#6d28d9" },
            accuracy: { bg: "#dcfce7", text: "#15803d" },
        };
        const hl = HIGHLIGHT[field] || HIGHLIGHT.total_score;
        const focusExam = isTotalView
            ? (exams.find((e) => summaryMetric.detail && e.exam_name === summaryMetric.detail) || sorted[0] || null)
            : null;
        const focusId = focusExam ? focusExam.exam_paper_id : null;
        const focusIdx = focusExam ? byDate.findIndex((e) => e.exam_paper_id === focusId) : -1;
        const focusRow = field === "average_score" ? "total" : field === "accuracy" ? "accuracy" : null;
        // The card's own figure (e.g. "72%"), as a number for the chart's reference line.
        const cardValue = parseFloat(summaryMetric.value);
        const avgLine = !isTotalView && !isNaN(cardValue)
            ? [{ value: cardValue, color: hl.text, width: 2, dashStyle: "Dash", zIndex: 5,
                label: { text: `${summaryMetric.label}: ${summaryMetric.value}`, align: "right", style: { color: hl.text, fontWeight: "700" } } }]
            : undefined;
        const chartOptions = {
            chart: { backgroundColor: "transparent", height: 360 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories: byDate.map((e) => e.exam_name || `Exam ${e.exam_paper_id}`), lineColor: "#e2e8f0", labels: { style: { color: "#64748b", fontWeight: "600" } },
                // Best Score: shade the best exam's slot.
                plotBands: focusIdx >= 0
                    ? [{ from: focusIdx - 0.5, to: focusIdx + 0.5, color: hl.bg, label: { text: `Best: ${summaryMetric.value}`, verticalAlign: "top", y: 14, style: { color: hl.text, fontWeight: "700" } } }]
                    : undefined,
            },
            yAxis: isTotalView
                ? [
                    { title: { text: "Score" }, gridLineColor: "#eef2f6", labels: { style: { color: "#64748b" } } },
                    { title: { text: "Accuracy %" }, opposite: true, max: 100, labels: { format: "{value}%", style: { color: "#64748b" } } },
                ]
                : [
                    { title: { text: field === "average_score" ? "Exam Score" : summaryMetric.label }, gridLineColor: "#eef2f6", max: field === "accuracy" ? 100 : undefined, labels: { style: { color: "#64748b" } }, plotLines: avgLine },
                ],
            tooltip: { shared: false, enabled: true },
            legend: { align: "center", verticalAlign: "top" },
            plotOptions: { column: { borderRadius: 5, groupPadding: 0.14, dataLabels: { enabled: true, format: isTotalView ? "{point.y}" : `{point.y}${metricSuffix}`, style: { fontWeight: "700", color: "#334155" } } }, spline: { dataLabels: { enabled: true, style: { fontWeight: "700", color: "#334155" } } } },
            series: isTotalView
                ? [
                    { name: "Total Score", type: "column", data: byDate.map((e) => e.totalScore), color: "#6366f1" },
                    { name: "Avg Score", type: "column", data: byDate.map((e) => e.avgScore), color: "#a855f7" },
                    { name: "Avg Accuracy %", type: "spline", yAxis: 1, data: byDate.map((e) => e.avgAccuracy), color: "#16a34a", lineWidth: 3, marker: { radius: 4 }, tooltip: { valueSuffix: "%" }, dataLabels: { enabled: true, format: "{point.y}%", style: { fontWeight: "700", color: "#16a34a" } } },
                ]
                : [
                    { name: field === "average_score" ? "Exam Score" : summaryMetric.label, type: "column", data: byDate.map((e) => metricValueOf(e)), color: metricColor, tooltip: { valueSuffix: metricSuffix } },
                ],
        };

        const chip = (icon, label, value, color) => (
            <span className="d-inline-flex align-items-center" style={{ gap: 6, padding: "5px 12px", borderRadius: 9, background: "#f4f3ff", border: "1px solid #e7e3fb", color: color || "#5b4fd6", fontSize: 12.5, fontWeight: 600 }}>
                <i className={`fas ${icon}`} style={{ fontSize: 11 }} /> {label}: <strong>{value}</strong>
            </span>
        );

        const seg = (view, icon, label) => (
            <button type="button" className={summaryView === view ? "active" : ""} onClick={() => this.setState({ summaryView: view })}>
                <i className={`fas ${icon}`} />{label}
            </button>
        );

        // Single pivot table: rows = subjects (union), columns = exams (chronological).
        const subjectRows = [];
        const subjSeen = new Set();
        byDate.forEach((e) => (e.subjects || []).forEach((s) => {
            const name = s.subject || `#${s.subject_id}`;
            if (!subjSeen.has(name)) { subjSeen.add(name); subjectRows.push(name); }
        }));
        const cellFor = (e, name) => (e.subjects || []).find((s) => (s.subject || `#${s.subject_id}`) === name) || null;

        return (
            <Modal show onHide={() => this.setState({ summaryModalOpen: false })} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontFamily: "'Outfit', sans-serif", fontSize: "17px" }}>
                        <i className={`fas ${summaryMetric.icon} mr-2`} style={{ color: summaryMetric.noteColor }} />
                        {summaryMetric.label} — Exam-wise Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-end mb-3">
                        <div className="sp-segment">
                            {seg("graph", "fa-chart-column", "Graph")}
                            {seg("table", "fa-table", "Table")}
                        </div>
                    </div>
                    {/* The clicked card's figure, in its highlight colour. */}
                    <div className="d-flex align-items-center flex-wrap mb-3 px-3 py-2" style={{ gap: 10, background: hl.bg, borderRadius: 10, color: hl.text }}>
                        <span style={{ fontSize: 13, fontWeight: 600 }}>{summaryMetric.label}</span>
                        <strong style={{ fontSize: 20, fontFamily: "'Outfit', sans-serif" }}>{summaryMetric.value}</strong>
                        <span style={{ fontSize: 12, fontWeight: 600 }}>
                            {isTotalView
                                ? (summaryMetric.detail ? `From ${summaryMetric.detail}${summaryMetric.detailDate ? ` · ${summaryMetric.detailDate}` : ""}` : "")
                                : field === "accuracy"
                                    ? `Correct ÷ attempted, ${summaryMetric.note || "across exams"}`
                                    : `Mean exam score, ${summaryMetric.note || "across exams"}`}
                        </span>
                    </div>
                    {exams.length === 0 ? (
                        <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>No exam-wise subject data available.</div>
                    ) : summaryView === "graph" ? (
                        <div style={{ borderRadius: 14, border: "1px solid #f1f2f5", padding: 16 }}>
                            <div className="font-weight-bold text-dark mb-2" style={{ fontSize: 14 }}>
                                {summaryMetric.label} — exam-wise
                            </div>
                            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                        </div>
                    ) : (
                        <>
                            {/* Cell format legend */}
                            {/* <div className="d-flex flex-wrap align-items-center mb-2" style={{ gap: 14, fontSize: 11.5, color: "#64748b" }}>
                                <span className="font-weight-bold text-muted">Each cell:</span>
                                <span><strong style={{ color: "#1e293b" }}>00</strong> Score</span>
                                <span><strong style={{ color: "#16a34a" }}>00%</strong> Accuracy</span>
                                <span><strong style={{ color: "#64748b" }}>00Q</strong> Questions attempted</span>
                            </div> */}
                            <div className="table-responsive" style={{ borderRadius: 12, border: "1px solid #f1f2f5" }}>
                            <table className="table mb-0" style={{ fontSize: 13 }}>
                                <thead>
                                    {/* Column headers = exam names */}
                                    <tr style={{ background: "#faf9ff" }}>
                                        <th style={{ fontSize: 11, textTransform: "uppercase", color: "#94a3b8", fontWeight: 700, padding: "10px 12px", position: "sticky", left: 0, background: "#faf9ff", minWidth: 120 }}>Subject</th>
                                        {byDate.map((e) => {
                                            const isTop = e.exam_paper_id === topId;
                                            const isFocus = focusId != null && e.exam_paper_id === focusId;
                                            return (
                                                <th key={e.exam_paper_id} className="text-center" style={{ fontSize: 11, fontWeight: 700, color: isFocus ? hl.text : isTop ? "#16a34a" : "#475569", padding: "10px 12px", minWidth: 120, background: isFocus ? hl.bg : undefined }}>
                                                    <div className="text-truncate" style={{ maxWidth: 160 }} title={e.exam_name}>
                                                        {e.exam_name || `Exam ${e.exam_paper_id}`}
                                                        {isTop ? <i className="fas fa-star ml-1" style={{ fontSize: 9, color: "#16a34a" }} /> : null}
                                                    </div>
                                                    {e.date ? <div className="text-muted" style={{ fontSize: 10, fontWeight: 400 }}>{e.date}</div> : null}
                                                </th>
                                            );
                                        })}
                                        {focusRow ? (
                                            <th className="text-center" style={{ fontSize: 11, fontWeight: 700, color: hl.text, padding: "10px 12px", background: hl.bg, whiteSpace: "nowrap", borderLeft: `2px solid ${hl.text}` }}>
                                                {summaryMetric.label}
                                            </th>
                                        ) : null}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Rows = subjects; cells = score + accuracy/attempted per exam */}
                                    {subjectRows.map((name) => (
                                        <tr key={name} style={{ borderTop: "1px solid #f4f4f7" }}>
                                            <td style={{ fontWeight: 700, color: "#1e293b", padding: "10px 12px", position: "sticky", left: 0, background: "#fff" }}>{name}</td>
                                            {byDate.map((e) => {
                                                const s = cellFor(e, name);
                                                const focusBg = focusId != null && e.exam_paper_id === focusId ? hl.bg : undefined;
                                                if (!s) return <td key={e.exam_paper_id} className="text-center text-muted" style={{ padding: "10px 12px", background: focusBg }}>-</td>;
                                                const acc = num(s.accuracy);
                                                return (
                                                    <td key={e.exam_paper_id} className="text-center" style={{ padding: "10px 12px", background: focusBg }}>
                                                        <div className="font-weight-bold" style={{ color: "#1e293b" }}>{num(s.score)}</div>
                                                        <div style={{ fontSize: 11, color: heatColor(acc) }}>
                                                            {acc}% · {num(s.attempted)}Q
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                            {focusRow ? <td style={{ borderLeft: `2px solid ${hl.text}` }} /> : null}
                                        </tr>
                                    ))}
                                    {/* Totals row */}
                                    {/* Summary rows. Avg Score highlights Total Score, Avg Accuracy
                                        highlights Avg Accuracy, each with the card's figure at the
                                        end; Best Score highlights its exam's column. */}
                                    {(() => {
                                        const rowBg = (row) => (focusRow === row ? hl.bg : "#faf9ff");
                                        const cellBg = (row, e) =>
                                            focusRow === row ? hl.bg : focusId != null && e.exam_paper_id === focusId ? hl.bg : undefined;
                                        const cardCell = (row) => (!focusRow ? null : focusRow === row ? (
                                            <td className="text-center font-weight-bold" style={{ color: hl.text, padding: "8px 12px", background: hl.bg, whiteSpace: "nowrap", borderLeft: `2px solid ${hl.text}` }}>
                                                {summaryMetric.value}
                                            </td>
                                        ) : <td style={{ borderLeft: `2px solid ${hl.text}` }} />);
                                        return (
                                            <>
                                                <tr style={{ borderTop: "2px solid #eef2f6", background: rowBg("total") }}>
                                                    <td style={{ fontWeight: 700, color: focusRow === "total" ? hl.text : "#4f46e5", padding: "10px 12px", position: "sticky", left: 0, background: rowBg("total") }}>Total Score</td>
                                                    {byDate.map((e) => (
                                                        <td key={e.exam_paper_id} className="text-center font-weight-bold" style={{ color: focusRow === "total" ? hl.text : "#4f46e5", padding: "10px 12px", background: cellBg("total", e) }}>{e.totalScore}</td>
                                                    ))}
                                                    {cardCell("total")}
                                                </tr>
                                                <tr style={{ background: rowBg("accuracy") }}>
                                                    <td style={{ fontWeight: 600, color: focusRow === "accuracy" ? hl.text : "#16a34a", padding: "8px 12px", position: "sticky", left: 0, background: rowBg("accuracy") }}>Avg Accuracy</td>
                                                    {byDate.map((e) => (
                                                        <td key={e.exam_paper_id} className="text-center font-weight-bold" style={{ color: focusRow === "accuracy" ? hl.text : "#16a34a", padding: "8px 12px", background: cellBg("accuracy", e) }}>{e.avgAccuracy}%</td>
                                                    ))}
                                                    {cardCell("accuracy")}
                                                </tr>
                                            </>
                                        );
                                    })()}
                                </tbody>
                            </table>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    // Exam-paper dropdown option for a matrix row. Keyed on the SESSION: a re-submitted
    // paper has two sessions with the same exam_paper_id, which made the paper id pick the
    // wrong one.
    matrixPaperOption = (m) => ({ value: String(m.session_id), label: `${m.exam_name || `Exam ${m.exam_paper_id}`}${m.date ? ` · ${m.date}` : ""}` });

    // Open the Best/Weak subject modal on the exam that explains it: for the Snapshot's
    // subject, the exam where it scored its highest accuracy (Best) or lowest (Weak),
    // latest exam on a tie. No subject / no such exam → the latest exam, as before.
    openSubjectMatrix = (title, subjectName = null) => {
        const matrix = this.state.examSubjectMatrix || [];
        const isBest = `${title}`.toLowerCase().includes("best");
        let pick = null;
        if (subjectName) {
            const byDate = [...matrix].sort((a, b) => parseExamDate(a.date) - parseExamDate(b.date));
            byDate.forEach((m) => {
                const s = (m.subjects || []).find((x) => x.subject === subjectName && num(x.attempted) > 0);
                if (!s) return;
                const acc = num(s.accuracy);
                if (!pick || (isBest ? acc >= pick.acc : acc <= pick.acc)) pick = { exam: m, acc };
            });
        }
        const exam = pick ? pick.exam : pickLatestExam(matrix);
        this.setState({
            subjectMatrixOpen: true,
            subjectMatrixTitle: title,
            subjectMatrixSubject: subjectName,
            subjectMatrixView: "graph",
            selectedMatrixPaper: exam ? this.matrixPaperOption(exam) : null,
        });
    };

    // Best/Weak Subject → modal with an exam-paper dropdown + stylish subject table.
    renderSubjectMatrixModal = () => {
        const { subjectMatrixOpen, subjectMatrixTitle, subjectMatrixSubject, examSubjectMatrix, selectedMatrixPaper } = this.state;
        if (!subjectMatrixOpen) return null;

        const paperOptions = examSubjectMatrix.map(this.matrixPaperOption);
        const latestExam = pickLatestExam(examSubjectMatrix);
        // Session id first; the paper id is the fallback for a selection made before it.
        const selVal = String(selectedMatrixPaper?.value);
        const selected =
            examSubjectMatrix.find((m) => String(m.session_id) === selVal) ||
            examSubjectMatrix.find((m) => String(m.exam_paper_id) === selVal) ||
            latestExam;
        const subjects = selected?.subjects || [];
        const isBest = `${subjectMatrixTitle}`.toLowerCase().includes("best");

        // Highlight the Snapshot's best/weak subject. When the Snapshot didn't name one
        // (or this exam doesn't have it), fall back to this exam's highest / lowest accuracy.
        let highlightId = null;
        const named = subjectMatrixSubject ? subjects.find((s) => s.subject === subjectMatrixSubject) : null;
        if (named) {
            highlightId = named.subject_id;
        } else if (subjects.length) {
            const sorted = [...subjects].sort((a, b) => num(b.accuracy) - num(a.accuracy));
            highlightId = (isBest ? sorted[0] : sorted[sorted.length - 1])?.subject_id;
        }
        const hlColor = isBest ? "#16a34a" : "#dc2626";
        const hlBg = isBest ? "#f0fdf4" : "#fef2f2";
        const hlCellBg = isBest ? "#bbf7d0" : "#fecaca";

        // The subject's accuracy over every exam (correct ÷ attempted), for the banner.
        let overallAcc = null;
        if (subjectMatrixSubject) {
            let att = 0, cor = 0;
            examSubjectMatrix.forEach((m) => (m.subjects || []).forEach((s) => {
                if (s.subject !== subjectMatrixSubject) return;
                att += num(s.attempted);
                cor += (num(s.accuracy) / 100) * num(s.attempted);
            }));
            overallAcc = att > 0 ? Math.round((cor / att) * 100) : null;
        }

        const th = { fontSize: 11, textTransform: "uppercase", color: "#94a3b8", fontWeight: 700, padding: "10px 12px", letterSpacing: "0.4px" };
        const view = this.state.subjectMatrixView;

        // Graph: per-subject Accuracy % (colored by strength) + Score, with best/weak highlighted.
        const subjChart = {
            chart: { backgroundColor: "transparent", height: 340 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: { categories: subjects.map((s) => s.subject || "-"), lineColor: "#e2e8f0", labels: { style: { color: "#64748b", fontWeight: "600" } } },
            yAxis: [
                { title: { text: "Accuracy %" }, max: 100, gridLineColor: "#eef2f6", labels: { format: "{value}%", style: { color: "#64748b" } } },
                { title: { text: "Score" }, opposite: true, gridLineColor: "#eef2f6", labels: { style: { color: "#64748b" } } },
            ],
            tooltip: { enabled: true, shared: false },
            legend: { align: "center", verticalAlign: "top" },
            plotOptions: { column: { borderRadius: 5, groupPadding: 0.14, dataLabels: { enabled: true, style: { fontWeight: "700", color: "#334155" } } } },
            series: [
                {
                    name: "Accuracy %",
                    type: "column",
                    data: subjects.map((s) => ({
                        y: num(s.accuracy),
                        color: s.subject_id === highlightId ? (isBest ? "#16a34a" : "#dc2626") : heatColor(num(s.accuracy)),
                    })),
                    dataLabels: { format: "{point.y}%" },
                },
                { name: "Score", type: "spline", yAxis: 1, data: subjects.map((s) => num(s.score)), color: "#6366f1", lineWidth: 3, marker: { radius: 4 } },
            ],
        };

        const seg = (v, icon, label) => (
            <button type="button" className={view === v ? "active" : ""} onClick={() => this.setState({ subjectMatrixView: v })}>
                <i className={`fas ${icon}`} />{label}
            </button>
        );

        // Pivot table: rows = subjects (union), columns = exams (chronological).
        const pivotExams = [...examSubjectMatrix].sort((a, b) => parseExamDate(a.date) - parseExamDate(b.date));
        const subjRows = [];
        const subjSeen = new Set();
        pivotExams.forEach((e) => (e.subjects || []).forEach((s) => {
            const name = s.subject || `#${s.subject_id}`;
            if (!subjSeen.has(name)) { subjSeen.add(name); subjRows.push(name); }
        }));
        const cellForSub = (e, name) => (e.subjects || []).find((s) => (s.subject || `#${s.subject_id}`) === name) || null;
        const highlightName = subjects.find((s) => s.subject_id === highlightId)?.subject || subjectMatrixSubject || null;
        const highlightCell = subjects.find((s) => s.subject_id === highlightId) || null;
        const isSelectedExam = (e) => selected && String(e.session_id) === String(selected.session_id);

        return (
            <Modal show onHide={() => this.setState({ subjectMatrixOpen: false, selectedMatrixPaper: null, subjectMatrixSubject: null })} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontFamily: "'Outfit', sans-serif", fontSize: "17px" }}>
                        <i className={`fas ${isBest ? "fa-star" : "fa-triangle-exclamation"} mr-2`} style={{ color: isBest ? "#16a34a" : "#dc2626" }} />
                        {subjectMatrixTitle} — Exam-wise Subject Breakdown
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Which subject the Snapshot named, and this exam's figures for it. */}
                    {highlightName ? (
                        <div className="d-flex align-items-center flex-wrap mb-3 px-3 py-2" style={{ gap: 10, background: hlBg, borderRadius: 10, color: hlColor }}>
                            <span style={{ fontSize: 13, fontWeight: 600 }}>{subjectMatrixTitle}</span>
                            <strong style={{ fontSize: 18, fontFamily: "'Outfit', sans-serif" }}>{highlightName}</strong>
                            {overallAcc != null ? <span style={{ fontSize: 12, fontWeight: 600 }}>{overallAcc}% accuracy across all exams</span> : null}
                            {highlightCell ? (
                                <span style={{ fontSize: 12, fontWeight: 600 }}>
                                    · this exam: {num(highlightCell.accuracy)}% · {num(highlightCell.score)} marks · {num(highlightCell.attempted)}Q
                                </span>
                            ) : null}
                        </div>
                    ) : null}
                    <div className="d-flex align-items-center flex-wrap mb-3" style={{ gap: 12 }}>
                        <span className="font-weight-bold text-muted" style={{ fontSize: 13 }}>Exam Paper</span>
                        <div style={{ minWidth: 230 }} className="batch-filter-select">
                            <SelectDropDown
                                stateData={selectedMatrixPaper || (latestExam ? this.matrixPaperOption(latestExam) : null)}
                                handleChange={(n, v, opt) => this.setState({ selectedMatrixPaper: opt })}
                                name="selectedMatrixPaper"
                                options={paperOptions}
                                placeholderName="Exam Paper"
                                dropdownIndicator={{ DropdownIndicator }}
                            />
                        </div>
                        {selected?.date ? <span className="text-muted" style={{ fontSize: 12 }}><i className="far fa-calendar mr-1" />{selected.date}</span> : null}
                        <div className="sp-segment ml-auto">
                            {seg("graph", "fa-chart-column", "Graph")}
                            {seg("table", "fa-table", "Table")}
                        </div>
                    </div>

                    {subjects.length === 0 ? (
                        <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>No subject data for this exam.</div>
                    ) : view === "graph" ? (
                        <div style={{ borderRadius: 12, border: "1px solid #f1f2f5", padding: 12 }}>
                            <HighchartsReact highcharts={Highcharts} options={subjChart} />
                        </div>
                    ) : (
                        <>
                            {/* Cell format legend */}
                            <div className="d-flex flex-wrap align-items-center mb-2" style={{ gap: 14, fontSize: 11.5, color: "#64748b" }}>
                                <span className="font-weight-bold text-muted">Each cell:</span>
                                <span><strong style={{ color: "#1e293b" }}>00</strong> Score</span>
                                <span><strong style={{ color: "#16a34a" }}>00%</strong> Accuracy</span>
                                <span><strong style={{ color: "#64748b" }}>00Q</strong> Questions attempted</span>
                            </div>
                            <div className="table-responsive" style={{ borderRadius: 12, border: "1px solid #f1f2f5" }}>
                            <table className="table mb-0" style={{ fontSize: 13 }}>
                                <thead>
                                    {/* Column headers = exam names */}
                                    <tr style={{ background: "#faf9ff" }}>
                                        <th style={{ ...th, position: "sticky", left: 0, background: "#faf9ff", minWidth: 120 }}>Subject</th>
                                        {pivotExams.map((e) => (
                                            <th key={e.session_id} style={{ ...th, textAlign: "center", minWidth: 120, ...(isSelectedExam(e) ? { background: hlBg, color: hlColor } : {}) }}>
                                                <div className="text-truncate" style={{ maxWidth: 160 }} title={e.exam_name}>{e.exam_name || `Exam ${e.exam_paper_id}`}</div>
                                                {e.date ? <div className="text-muted" style={{ fontSize: 10, fontWeight: 400, textTransform: "none" }}>{e.date}</div> : null}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Rows = subjects; the best/weak subject row is highlighted */}
                                    {subjRows.map((name) => {
                                        const hl = highlightName != null && name === highlightName;
                                        return (
                                            <tr key={name} style={{ background: hl ? (isBest ? "#f0fdf4" : "#fef2f2") : "#fff", borderTop: "1px solid #f4f4f7" }}>
                                                <td style={{ padding: "12px", fontWeight: 700, color: "#1e293b", position: "sticky", left: 0, background: hl ? (isBest ? "#f0fdf4" : "#fef2f2") : "#fff" }}>
                                                    {name}
                                                    {hl ? (
                                                        <span className="ml-2" style={{ fontSize: 10, fontWeight: 700, color: isBest ? "#16a34a" : "#dc2626", background: isBest ? "#dcfce7" : "#fee2e2", borderRadius: 6, padding: "2px 7px" }}>
                                                            {isBest ? "BEST" : "WEAK"}
                                                        </span>
                                                    ) : null}
                                                </td>
                                                {pivotExams.map((e) => {
                                                    const s = cellForSub(e, name);
                                                    // Selected exam's column is tinted; the subject's cell in it is marked.
                                                    const colSel = isSelectedExam(e);
                                                    const cellBg = colSel ? (hl ? hlCellBg : hlBg) : undefined;
                                                    const cellBorder = colSel && hl ? { boxShadow: `inset 0 0 0 2px ${hlColor}` } : {};
                                                    if (!s) return <td key={e.session_id} className="text-center text-muted" style={{ padding: "12px", background: cellBg, ...cellBorder }}>-</td>;
                                                    const acc = num(s.accuracy);
                                                    return (
                                                        <td key={e.session_id} className="text-center" style={{ padding: "12px", background: cellBg, ...cellBorder }}>
                                                            <div className="font-weight-bold" style={{ color: "#1e293b" }}>{num(s.score)}</div>
                                                            <div style={{ fontSize: 11, color: heatColor(acc) }}>{acc}% · {num(s.attempted)}Q</div>
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        );
    };
    // Chapter-comparison table columns (flattened across sections).
    // Student-only chapter table: his subjects → his chapters → his accuracy.
    // No branch/section. "—" where a chapter hasn't been attempted.
    batchChapterColumns = [
        { dataField: "subject", text: "Subject", sort: true, formatter: (cell) => this.formatValue(cell) },
        { dataField: "chapter", text: "Chapter", sort: true, formatter: (cell) => this.formatValue(cell) },
        // The chapter's own question counts — the same figures as its heatmap tile and the
        // topic popup. Topic questions are a subset of the chapter's, so they are not added.
        {
            dataField: "attempted_q", text: "Attempted", sort: true,
            formatter: (cell) => <b>{this.formatValue(cell)}</b>,
        },
        {
            dataField: "correct_q", text: "Correct", sort: true,
            formatter: (cell) => <b style={{ color: "#16a34a" }}>{this.formatValue(cell)}</b>,
        },
        {
            dataField: "wrong_q", text: "Wrong", sort: true,
            formatter: (cell) => <b style={{ color: "#dc2626" }}>{this.formatValue(cell)}</b>,
        },
        {
            dataField: "accuracy",
            text: "Accuracy",
            sort: true,
            formatter: (cell) => (cell != null ? `${num(cell)}%` : "—"),
        },
    ];

    // Clicking a heatmap cell opens a detail modal for that section + subject + chapter.
    // The 3rd arg is a CHAPTER name (heatmap columns are chapters), so topics are
    // filtered by chapter — matching on trimmed names to survive padded values.
    openBatchDetail = (sec, subject, chapter, value) => {
        const label = sec.section_name || `Section ${sec.section_id}`;
        const chapKey = chapter != null ? String(chapter).trim() : "";
        const chapters = (sec.chapters || []).filter(
            (c) => c.subject === subject && (!chapKey || String(c.chapter || "").trim() === chapKey)
        );
        const topics = (sec.topics || []).filter(
            (t) => t.subject === subject && (!chapKey || String(t.chapter || "").trim() === chapKey)
        );
        this.setState({
            batchDetail: {
                sectionLabel: label,
                branchName: sec.branch_name,
                subject,
                chapter,
                value,
                studentCount: sec.student_count,
                chapters,
                topics,
            },
        });
    };

    closeBatchDetail = () => this.setState({ batchDetail: null });

    renderBatchDetailModal = () => {
        const d = this.state.batchDetail;
        if (!d) return null;
        const chipStyle = {
            display: "inline-flex", alignItems: "center", gap: 6, padding: "5px 12px",
            borderRadius: 9, background: "#f4f3ff", border: "1px solid #e7e3fb",
            color: "#5b4fd6", fontSize: 12.5, fontWeight: 600,
        };
        const accCell = (v) => (
            <span className="font-weight-bold" style={{ color: v == null ? "#94a3b8" : heatColor(num(v)) }}>
                {v == null ? "-" : `${num(v)}%`}
            </span>
        );
        return (
            <Modal show onHide={this.closeBatchDetail} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontFamily: "'Outfit', sans-serif", fontSize: "17px" }}>
                        {d.sectionLabel}{d.branchName ? ` — ${d.branchName}` : ""} · {d.subject}{d.chapter ? ` · ${d.chapter}` : ""}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-wrap mb-3" style={{ gap: 10 }}>
                        <span style={chipStyle}><i className="fas fa-bullseye" style={{ fontSize: 11 }} /> Accuracy {d.value == null ? "—" : `${d.value}%`}</span>
                        {d.studentCount != null && (
                            <span style={chipStyle}><i className="fas fa-user-graduate" style={{ fontSize: 11 }} /> {num(d.studentCount)} Students</span>
                        )}
                        <span style={chipStyle}><i className="fas fa-book" style={{ fontSize: 11 }} /> {d.chapters.length} Chapters</span>
                        <span style={chipStyle}><i className="fas fa-list" style={{ fontSize: 11 }} /> {d.topics.length} Topics</span>
                    </div>

                    <h6 className="font-weight-bold text-dark mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                        <i className="fas fa-book mr-2" style={{ color: "#7c3aed" }} />Chapters
                    </h6>
                    {d.chapters.length > 0 ? (
                        <div className="table-responsive mb-4">
                            <table className="table table-borderless mb-0" style={{ fontSize: 13 }}>
                                <thead>
                                    <tr style={{ borderBottom: "1px solid #eef2f6" }}>
                                        <th className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Chapter</th>
                                        <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase" }}>Avg Accuracy</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {d.chapters.map((c, i) => (
                                        <tr key={c.chapter_id ?? `${c.chapter}-${i}`} style={{ borderBottom: "1px solid #f6f8fb" }}>
                                            <td className="text-dark font-weight-bold">{this.formatValue(c.chapter)}</td>
                                            <td className="text-right">{accCell(c.avg_accuracy)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-muted mb-4" style={{ fontSize: 13 }}>No chapter data.</div>
                    )}

                    <h6 className="font-weight-bold text-dark mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                        <i className="fas fa-list mr-2" style={{ color: "#7c3aed" }} />Topics
                    </h6>
                    {d.topics.length > 0 ? (
                        <div className="table-responsive">
                            <table className="table table-borderless mb-0" style={{ fontSize: 13 }}>
                                <thead>
                                    <tr style={{ borderBottom: "1px solid #eef2f6" }}>
                                        <th className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Chapter</th>
                                        <th className="text-muted" style={{ fontSize: 11, textTransform: "uppercase" }}>Topic</th>
                                        <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase" }}>Avg Accuracy</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {d.topics.map((t, i) => (
                                        <tr key={t.topic_id ?? `${t.topic}-${i}`} style={{ borderBottom: "1px solid #f6f8fb" }}>
                                            <td className="text-muted">{this.formatValue(t.chapter)}</td>
                                            <td className="text-dark font-weight-bold">{this.formatValue(t.topic)}</td>
                                            <td className="text-right">{accCell(t.avg_accuracy)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="text-muted" style={{ fontSize: 13 }}>No topic data.</div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    // Build the student's full chapter list, subject-wise: EVERY chapter offered in
    // his subjects (master list from the batch syllabus, scoped to his stream's
    // subjects), each tagged with HIS own accuracy (null where not attempted).
    // Returns rows { subject, subject_id, chapter, accuracy } sorted subject→chapter.
    buildStudentChapterRows = (scopedSections, isAllowedSubject) => {
        const norm = (s) => `${s == null ? "" : s}`.trim().toLowerCase();

        // His own attempted-chapter accuracies, keyed by subject+chapter.
        // A chapter name can come back more than once for a subject (two chapter ids sharing a
        // name), and the last row used to overwrite the first. Rows are pooled instead:
        // correct = accuracy × attempted per row, so accuracy = Σcorrect ÷ Σattempted.
        const youChapters = this.state.chapterPerformance || [];
        const accByKey = {};
        const statsByKey = {};
        youChapters.forEach((c) => {
            if (c.accuracy_percentage == null || `${c.accuracy_percentage}` === "") return;
            const key = `${norm(c.subject)}::${norm(c.chapter)}`;
            const att = num(c.attempted);
            const cur = statsByKey[key] || { attempted: 0, correct: 0, pctOnly: [], chapterIds: [] };
            if (c.chapter_id != null) cur.chapterIds.push(String(c.chapter_id));
            if (att > 0) {
                cur.attempted += att;
                cur.correct += (num(c.accuracy_percentage) / 100) * att;
            } else {
                cur.pctOnly.push(num(c.accuracy_percentage)); // older backend: no counts
            }
            statsByKey[key] = cur;
        });
        Object.keys(statsByKey).forEach((key) => {
            const s = statsByKey[key];
            accByKey[key] = s.attempted > 0
                ? Math.round((s.correct / s.attempted) * 10000) / 100
                : s.pctOnly[s.pctOnly.length - 1];
        });
        const countsFor = (key) => {
            const s = statsByKey[key];
            // chapterIds: every chapter_id behind this row (one name can carry several).
            return s && s.attempted > 0
                ? { attempted_q: s.attempted, correct_q: Math.round(s.correct), chapterIds: s.chapterIds }
                : { attempted_q: null, correct_q: null, chapterIds: s ? s.chapterIds : [] };
        };

        // Master chapter list: prefer the FULL syllabus (all chapters of his subjects,
        // attempted or not). Fall back to batch-derived chapters when the syllabus
        // isn't available (e.g. state exams / syllabus tables unreachable).
        const syllabus = this.state.syllabusChapters || [];
        const seen = new Set();
        const rows = [];
        const pushRow = (subject, subject_id, chapter, topic_count) => {
            const s = subject != null ? String(subject).trim() : "";
            const c = chapter != null ? String(chapter).trim() : "";
            if (!s || !c) return;
            const key = `${norm(s)}::${norm(c)}`;
            if (seen.has(key)) return;
            seen.add(key);
            const acc = accByKey[key];
            rows.push({ subject: s, subject_id, chapter: c, topic_count: topic_count || 0, accuracy: acc != null ? acc : null, attempted: acc != null, ...countsFor(key) });
        };

        if (syllabus.length > 0) {
            syllabus.forEach((ch) => pushRow(ch.subject, ch.subject_id, ch.chapter, ch.topic_count));
        } else {
            // Fallback: distinct chapters from the batch, scoped to the stream's subjects.
            scopedSections.forEach((sec) =>
                (sec.chapters || []).forEach((ch) => {
                    if (!isAllowedSubject(ch.subject_id)) return;
                    pushRow(ch.subject, ch.subject_id, ch.chapter, 0);
                })
            );
        }

        // Then anything he actually ATTEMPTED that the master list above does not carry.
        // The syllabus is a mapping and does not always cover every chapter a paper drew
        // from, so keying the table off it alone silently dropped real results — one
        // student had 5 of 21 scored chapters missing, including a 0%, which is precisely
        // the weakness this card exists to surface. pushRow de-dupes, so chapters already
        // listed are untouched.
        youChapters.forEach((c) => {
            if (c.accuracy_percentage == null || `${c.accuracy_percentage}` === "") return;
            pushRow(c.subject, c.subject_id, c.chapter, 0);
        });

        // Sort subject-wise, then chapter A→Z.
        rows.sort((a, b) => (a.subject === b.subject ? a.chapter.localeCompare(b.chapter) : a.subject.localeCompare(b.subject)));
        return rows;
    };

    // Chapter tile click → collect this chapter's topics (student's own topic-wise
    // accuracy + attempted counts) and open the popup.
    openChapterTopics = (subject, chapter, chapterRow = null) => {
        const norm = (s) => `${s == null ? "" : s}`.trim().toLowerCase();
        // One row per topic: a topic name can repeat across ids, so rows are pooled the same
        // way chapters are (Σcorrect ÷ Σattempted), with correct counts shown alongside.
        const byTopic = new Map();
        (this.state.topicPerformance || [])
            .filter((t) => norm(t.subject) === norm(subject) && norm(t.chapter) === norm(chapter))
            .forEach((t) => {
                const name = t.topic || "-";
                const att = t.attempted != null ? num(t.attempted) : 0;
                const cur = byTopic.get(norm(name)) || { topic: name, attempted: 0, correct: 0, pct: null };
                cur.attempted += att;
                cur.correct += t.accuracy_percentage != null ? (num(t.accuracy_percentage) / 100) * att : 0;
                if (t.accuracy_percentage != null) cur.pct = num(t.accuracy_percentage);
                byTopic.set(norm(name), cur);
            });
        const topics = [...byTopic.values()]
            .map((t) => ({
                topic: t.topic,
                attempted: t.attempted,
                correct: t.attempted > 0 ? Math.round(t.correct) : null,
                accuracy: t.attempted > 0 ? Math.round((t.correct / t.attempted) * 10000) / 100 : t.pct,
            }))
            .sort((a, b) => (a.accuracy == null) - (b.accuracy == null) || num(a.accuracy) - num(b.accuracy));
        // The chapter's own figures (same as its heatmap tile / table row).
        const summary = chapterRow && chapterRow.accuracy != null
            ? { accuracy: chapterRow.accuracy, attempted: chapterRow.attempted_q, correct: chapterRow.correct_q }
            : null;

        // Topic counts worked out here from the CHAPTER's own counts, not the API's per-topic
        // counts: a question tagged with several topics is counted under each of them by the
        // API, so its topics out-count the chapter (5 + 5 + 2 attempts in a 6-attempt chapter).
        // The chapter's attempted is shared across its topics by each topic's share of attempts,
        // its correct by each topic's share of correct answers (never more than that topic's
        // attempted); wrong = attempted − correct. The topics then add up exactly to the chapter.
        if (summary && summary.attempted != null && topics.length) {
            const chAtt = num(summary.attempted);
            const chCor = Math.min(num(summary.correct), chAtt);
            const att = splitByShare(chAtt, topics.map((t) => num(t.attempted)));
            const cor = splitByShare(chCor, topics.map((t) => num(t.correct)));
            // A topic can't have more correct than attempted: move any excess to topics with room.
            for (let i = 0; i < cor.length; i++) {
                let excess = cor[i] - att[i];
                if (excess <= 0) continue;
                cor[i] = att[i];
                for (let j = 0; j < cor.length && excess > 0; j++) {
                    const room = att[j] - cor[j];
                    if (j === i || room <= 0) continue;
                    const give = Math.min(room, excess);
                    cor[j] += give;
                    excess -= give;
                }
            }
            topics.forEach((t, i) => {
                t.attempted = att[i];
                t.correct = cor[i];
                t.wrong = att[i] - cor[i];
                t.accuracy = att[i] > 0 ? Math.round((cor[i] / att[i]) * 10000) / 100 : null;
            });
            topics.sort((a, b) => (a.accuracy == null) - (b.accuracy == null) || num(a.accuracy) - num(b.accuracy));
            summary.wrong = chAtt - chCor;
            summary.split = true;
        }
        this.setState({ chapterTopicModal: { subject, chapter, topics, summary } });
    };

    closeChapterTopics = () => this.setState({ chapterTopicModal: null });

    // Popup: topic-wise accuracy for the clicked chapter.
    renderChapterTopicModal = () => {
        const m = this.state.chapterTopicModal;
        if (!m) return null;
        return (
            <Modal show onHide={this.closeChapterTopics} centered size="xl">
                <Modal.Header closeButton style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <div>
                        <div className="text-muted" style={{ fontSize: 11.5, fontWeight: 600 }}>{m.subject}</div>
                        <Modal.Title className="h6 font-weight-bold mb-0">{m.chapter}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-0">
                    {/* The chapter's own figures — identical to its heatmap tile and table row. */}
                    {m.summary ? (
                        <div className="d-flex align-items-center flex-wrap px-3 py-2" style={{ gap: 12, background: "#f8fafc", borderBottom: "1px solid #f1f5f9", fontSize: 12.5 }}>
                            <span className="font-weight-bold" style={{ color: "#0f172a" }}>
                                <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: heatColor(m.summary.accuracy), marginRight: 6 }} />
                                Chapter accuracy {m.summary.accuracy}%
                            </span>
                            {m.summary.attempted != null ? (
                                <span className="text-muted">{m.summary.correct} correct of {m.summary.attempted} attempted</span>
                            ) : null}
                            <span className="text-muted" style={{ fontSize: 11 }}>
                                {m.summary.split
                                    ? "Topic counts share the chapter's own counts by each topic's share of attempts — they add up to the chapter total."
                                    : "Topic rows cover only questions tagged with a topic."}
                            </span>
                        </div>
                    ) : null}
                    {m.topics.length === 0 ? (
                        <div className="text-center text-muted py-4" style={{ fontSize: 13 }}>
                            <i className="fas fa-list-ul d-block mb-2" style={{ fontSize: 22, color: "#cbd5e1" }} />
                            No topic-level data for this chapter yet.
                        </div>
                    ) : (
                        <table className="sp-doubts-table" style={{ minWidth: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Topic</th>
                                    <th className="text-center" style={{ width: 90 }}>Attempted</th>
                                    <th className="text-center" style={{ width: 80 }}>Correct</th>
                                    <th className="text-center" style={{ width: 70 }}>Wrong</th>
                                    <th className="text-center" style={{ width: 100 }}>Accuracy</th>
                                </tr>
                            </thead>
                            <tbody>
                                {m.topics.map((t, i) => (
                                    <tr key={i} style={{ cursor: "default" }}>
                                        <td style={{ fontWeight: 600, color: "#334155" }}>{t.topic}</td>
                                        <td className="text-center text-muted">{t.attempted || "—"}</td>
                                        <td className="text-center text-muted">{t.correct != null ? t.correct : "—"}</td>
                                        <td className="text-center text-muted">{t.wrong != null ? t.wrong : (t.correct != null && t.attempted ? t.attempted - t.correct : "—")}</td>
                                        <td className="text-center">
                                            {t.accuracy == null ? (
                                                <span className="text-muted">—</span>
                                            ) : (
                                                <span style={{ fontWeight: 700, color: heatColor(t.accuracy) === "#f8fafc" ? "#94a3b8" : "#0f172a" }}>
                                                    <span style={{ display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: heatColor(t.accuracy), marginRight: 6 }} />
                                                    {t.accuracy}%
                                                </span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                {m.summary && m.summary.split ? (
                                    // Topics total (bottom row) = the chapter total (the split is exact).
                                    <tr style={{ cursor: "default", background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}>
                                        <td style={{ fontWeight: 800, color: "#334155" }}>Topics total</td>
                                        <td className="text-center" style={{ fontWeight: 800 }}>{m.topics.reduce((a, t) => a + num(t.attempted), 0)}</td>
                                        <td className="text-center" style={{ fontWeight: 800, color: "#16a34a" }}>{m.topics.reduce((a, t) => a + num(t.correct), 0)}</td>
                                        <td className="text-center" style={{ fontWeight: 800, color: "#dc2626" }}>{m.topics.reduce((a, t) => a + num(t.wrong), 0)}</td>
                                        <td className="text-center" style={{ fontWeight: 800 }}>{m.summary.accuracy}%</td>
                                    </tr>
                                ) : null}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    // Chapter-wise accuracy heatmap — THIS STUDENT ONLY, SUBJECT-WISE.
    // One block per subject; a wrapped grid of the chapters he has ATTEMPTED, coloured by
    // his accuracy. Unattempted chapters are left out: the master list is the whole
    // syllabus, so showing them buried the real results under a grid of blanks (one
    // student had 10 scores among 49 chapters, and the visible top of the grid was empty).
    renderBatchHeatmap = (scopedSections, selectedSubject = "all", isAllowedSubject) => {
        const rows = this.buildStudentChapterRows(scopedSections, isAllowedSubject || (() => true))
            // Keep a genuine 0% — that is a real result, not an absence of one.
            .filter((r) => r.accuracy != null);
        const filtered = selectedSubject && selectedSubject !== "all"
            ? rows.filter((r) => r.subject === selectedSubject)
            : rows;

        if (filtered.length === 0) {
            return (
                <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>
                    <i className="fas fa-book-open d-block mb-2" style={{ fontSize: 26, color: "#cbd5e1" }} />
                    No chapters for {selectedSubject && selectedSubject !== "all" ? "this subject" : "this student"} yet.
                </div>
            );
        }

        // Group chapters by subject.
        const bySubject = [];
        const idx = {};
        filtered.forEach((r) => {
            if (idx[r.subject] == null) { idx[r.subject] = bySubject.length; bySubject.push({ subject: r.subject, chapters: [] }); }
            bySubject[idx[r.subject]].chapters.push(r);
        });

        return (
            <div>
                {/* Color-code legend */}
                <div className="d-flex align-items-center justify-content-center flex-wrap mb-3" style={{ gap: 8, fontSize: 11.5, color: "#64748b" }}>
                    <span>Weak</span>
                    {["#ef4444", "#f97316", "#f59e0b", "#84cc16", "#22c55e"].map((c) => (
                        <span key={c} style={{ width: 24, height: 12, borderRadius: 3, background: c, display: "inline-block" }} />
                    ))}
                    <span>Strong</span>
                    <span className="ml-2" style={{ color: "#94a3b8" }}>· “—” = not attempted</span>
                </div>

                {bySubject.map((grp) => (
                    <div key={grp.subject} className="mb-3">
                        <div className="font-weight-bold text-dark mb-2" style={{ fontSize: 13, fontFamily: "'Outfit', sans-serif" }}>
                            {grp.subject}
                            <span className="text-muted font-weight-normal ml-2" style={{ fontSize: 11 }}>{grp.chapters.length} chapters</span>
                        </div>
                        <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                            {grp.chapters.map((c) => {
                                const v = c.accuracy;
                                return (
                                    <div
                                        key={c.chapter}
                                        className="sp-cx-tile"
                                        title={`${c.subject} · ${c.chapter}: ${v == null ? "not attempted" : `${v}%${c.attempted_q != null ? ` (${c.correct_q} correct of ${c.attempted_q} attempted)` : ""}`} — click for topics`}
                                        onClick={() => this.openChapterTopics(c.subject, c.chapter, c)}
                                        style={{
                                            width: 108, minHeight: 58, borderRadius: 10, padding: "8px 8px",
                                            background: v == null ? "#f8fafc" : heatColor(v),
                                            border: v == null ? "1px dashed #e2e8f0" : "1px solid rgba(0,0,0,0.06)",
                                            color: v == null ? "#94a3b8" : "#fff",
                                            display: "flex", flexDirection: "column", justifyContent: "space-between",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <span style={{ fontSize: 10, fontWeight: 600, lineHeight: 1.2 }}>{trunc(c.chapter, 34)}</span>
                                        <span className="d-flex align-items-end justify-content-between" style={{ gap: 4 }}>
                                            {/* correct / attempted questions behind the % */}
                                            <span style={{ fontSize: 9.5, fontWeight: 700, opacity: 0.9 }}>
                                                {v != null && c.attempted_q != null ? `${c.correct_q}/${c.attempted_q}Q` : ""}
                                            </span>
                                            <span style={{ fontSize: 13, fontWeight: 800, textAlign: "right" }}>{v == null ? "—" : `${v}%`}</span>
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    // Batch-wise average score comparison — grouped columns (subjects × sections) + chapters table.
    // Loader shown in the batch section's own card while getBatchComparison runs
    // (it fetches separately from the main report and can be slow, sometimes with a
    // second fallback call) — so the user sees a spinner, not stale/empty data.
    renderBatchLoading = () => (
        <div className="sp-af-card p-4 mt-2" style={{ borderRadius: 16 }}>
            <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
                <div className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0"
                    style={{ width: 42, height: 42, borderRadius: 12, background: "linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)" }}>
                    <i className="fas fa-layer-group" style={{ fontSize: 17 }} />
                </div>
                <div>
                    <h6 className="font-weight-bold text-dark mb-0" style={{ fontFamily: "'Outfit', sans-serif", fontSize: 16 }}>
                        Batch-wise Average Score Comparison
                    </h6>
                    <span className="text-muted" style={{ fontSize: 12.5 }}>Loading batch data…</span>
                </div>
            </div>
            <div className="text-center text-muted py-5">
                <i className="fas fa-circle-notch fa-spin" style={{ fontSize: 26, color: "#6366f1" }} />
                <div className="mt-2" style={{ fontSize: 13 }}>Comparing against your class &amp; stream…</div>
            </div>
        </div>
    );

    renderBatchComparison = (sections) => {
        // Scope the comparison to the student's stream (MPC or BIPC) — strictly by SUBJECT.
        // We do NOT classify whole sections by stream (a section can carry stray cross-stream
        // questions); instead we keep only the stream's subjects and drop sections that have none.
        const stream = resolveStudentStream(this.props.student, this.state.subjectPerformance);
        const allowedIds = stream ? STREAM_SUBJECT_IDS[stream] : null;
        // Only the student's stream sections should display: a section qualifies only if it
        // carries the stream's DEFINING subject (MPC => Maths; BIPC => Botany/Zoology).
        const definingIds = stream ? STREAM_DEFINING_IDS[stream] : null;
        const sectionInStream = (sec) =>
            !definingIds || (sec.subjects || []).some((s) => definingIds.has(num(s.subject_id)));
        // Multiple branches exist under the same institution_id — compare across all of them.
        const filteredSections = definingIds ? sections.filter(sectionInStream) : sections;
        // Keep the stream filter STRICT: a JEE (MPC) student must NEVER see NEET
        // (BIPC) sections/subjects, even if the stream filter leaves nothing (that
        // just means no batch data for the current filter → show empty, not all).
        const streamSections = filteredSections;
        // The subject allowlist ALWAYS applies when we know the stream, so stray
        // cross-stream subjects (e.g. Botany/Zoology bars for a JEE student) are
        // dropped from every section that is shown.
        const effectiveAllowed = allowedIds || null;
        const isAllowedSubject = (sid) => !effectiveAllowed || effectiveAllowed.has(num(sid));

        // Branch filter options derived from the stream-scoped data (distinct branches).
        const branchOptions = [];
        const seenBranch = new Set();
        streamSections.forEach((sec) => {
            const id = sec.branch_id != null ? String(sec.branch_id) : sec.branch_name;
            if (id != null && !seenBranch.has(id)) {
                seenBranch.add(id);
                branchOptions.push({ value: id, label: sec.branch_name || `Branch ${id}` });
            }
        });

        // Default scope = the student's OWN branch/section (not all sections). The dropdowns
        // still let the user widen the comparison; "not touched" (null) uses the own-batch default.
        const stu = this.props.student || {};
        const stuBranchKey = stu.branch_id != null ? String(stu.branch_id) : (stu.branch_name ? String(stu.branch_name) : null);

        // null selection = "not touched" → default to the student's own branch (fall back to all).
        const ownBranch = stuBranchKey ? branchOptions.filter((b) => String(b.value) === stuBranchKey) : [];
        const defaultBranchSel = ownBranch.length ? ownBranch : branchOptions;
        const branchSel = this.state.batchBranchSel === null ? defaultBranchSel : this.state.batchBranchSel;
        const branchSelValues = new Set(branchSel.map((b) => b.value));
        const branchScoped = streamSections.filter((sec) =>
            branchSelValues.has(String(sec.branch_id != null ? sec.branch_id : sec.branch_name))
        );

        // Section filter options derived from the branch-scoped data (distinct sections).
        const sectionOptions = [];
        const seenSection = new Set();
        branchScoped.forEach((sec) => {
            const id = sec.section_id != null ? String(sec.section_id) : sec.section_name;
            if (id != null && !seenSection.has(id)) {
                seenSection.add(id);
                sectionOptions.push({ value: id, label: sec.section_name || `Section ${id}` });
            }
        });

        // null selection = "not touched" → default to ALL sections selected.
        const defaultSectionSel = sectionOptions;
        const sectionSel = this.state.batchSectionSel === null ? defaultSectionSel : this.state.batchSectionSel;
        const sectionSelValues = new Set(sectionSel.map((s) => s.value));
        const scopedSections = branchScoped.filter((sec) =>
            sectionSelValues.has(String(sec.section_id != null ? sec.section_id : sec.section_name))
        );

        // Union of the stream's subject names across scoped sections, in first-seen order.
        const subjectNames = [];
        scopedSections.forEach((sec) =>
            (sec.subjects || []).forEach((s) => {
                if (s.subject && isAllowedSubject(s.subject_id) && !subjectNames.includes(s.subject)) {
                    subjectNames.push(s.subject);
                }
            })
        );

        const series = scopedSections
            .map((sec, i) => {
                const byName = {};
                (sec.subjects || []).forEach((s) => {
                    if (isAllowedSubject(s.subject_id)) byName[s.subject] = num(s.avg_accuracy);
                });
                const secLabel = sec.section_name || `Section ${sec.section_id}`;
                return {
                    // Explicit type so a section can never inherit the student spline's type
                    // when Highcharts reconciles series by index after a check/uncheck.
                    type: "column",
                    name: sec.branch_name ? `${secLabel} — ${sec.branch_name}` : secLabel,
                    data: subjectNames.map((n) => (byName[n] != null ? byName[n] : null)),
                    color: BATCH_COLORS[i % BATCH_COLORS.length],
                };
            })
            // Drop sections with no data for the stream's subjects.
            .filter((s) => s.data.some((v) => v != null));

        // Overlay the student's own per-subject accuracy as a highlighted line, for direct comparison.
        const studentAccBySubject = {};
        (this.state.subjectPerformance || []).forEach((sp) => {
            if (sp.subject != null) studentAccBySubject[sp.subject] = num(sp.accuracy);
        });
        const studentData = subjectNames.map((n) =>
            studentAccBySubject[n] != null ? studentAccBySubject[n] : null
        );
        if (studentData.some((v) => v != null)) {
            // Unshift so "You" shows first (top) in the legend; zIndex keeps it drawn on top.
            series.unshift({
                name: "You",
                type: "spline",
                data: studentData,
                color: "#111827",
                lineWidth: 3,
                zIndex: 5,
                marker: { enabled: true, radius: 5, symbol: "circle", fillColor: "#111827" },
            });
        }

        const options = {
            chart: { type: "column", backgroundColor: "transparent", height: 340 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories: subjectNames,
                lineColor: "#e2e8f0",
                labels: { style: { color: "#64748b", fontWeight: "600" } },
            },
            yAxis: {
                min: 0,
                max: 100,
                title: { text: "Avg Accuracy (%)" },
                gridLineColor: "#eef2f6",
                labels: { style: { color: "#64748b" } },
            },
            tooltip: { shared: false, valueSuffix: "%", enabled: true },
            legend: { align: "center", verticalAlign: "top" },
            plotOptions: { column: { borderRadius: 4, groupPadding: 0.12, pointPadding: 0.04, dataLabels: { enabled: true, style: { fontWeight: "700", color: "#334155" } } }, spline: { dataLabels: { enabled: true, style: { fontWeight: "700", color: "#334155" } } } },
            series,
        };

        // ---- THIS STUDENT'S chapters, subject-wise (ALL chapters of his subjects,
        // attempted or not) ---- The master chapter list comes from the batch syllabus
        // (every chapter offered in his class+stream), scoped to HIS subjects; the
        // accuracy is his own (null where he hasn't attempted). No branch/section.
        const studentChapterRows = this.buildStudentChapterRows(scopedSections, isAllowedSubject);
        const chapterRows = studentChapterRows; // for any downstream refs

        // Subject filter (drives both the heatmap columns and the table rows).
        const subjectFilterOptions = [{ value: "all", label: "All Subjects" }].concat(
            subjectNames.map((n) => ({ value: n, label: n }))
        );
        const selectedSubject = this.state.batchSubjectSel?.value || "all";
        // Only chapters he has actually attempted. The master list is the full syllabus, so
        // most rows carry no score — a table that opens on dashes buries the real results.
        // Unattempted chapters remain in studentChapterRows for the heatmap.
        const tableRows = studentChapterRows
            .filter((r) => r.accuracy != null)
            .filter((r) => selectedSubject === "all" || r.subject === selectedSubject)
            // Chapter + topic performance combined on the same chapter_id: the chapter's own
            // counts plus every TopicPerformance row of that chapter_id. Correct = accuracy ×
            // attempted per row; wrong = attempted − correct; accuracy = correct ÷ attempted.
            .map((r) => {
                let attempted = num(r.attempted_q);
                let correct = num(r.attempted_q) > 0 ? num(r.correct_q) : 0;
                (this.state.topicPerformance || [])
                    .filter((t) => r.chapterIds.includes(String(t.chapter_id)))
                    .forEach((t) => {
                        attempted += num(t.attempted);
                        correct += (num(t.accuracy_percentage) / 100) * num(t.attempted);
                    });
                correct = Math.round(correct);
                return {
                    ...r,
                    attempted_q: attempted,
                    correct_q: correct,
                    wrong_q: attempted - correct,
                    accuracy: attempted > 0 ? Math.round((correct / attempted) * 10000) / 100 : r.accuracy,
                };
            });
        const batchView = this.state.batchView;

        // Chip counts reflect the current branch/section selection (scopedSections); the chips
        // themselves stay visible whenever the batch has data (gated on streamSections below).
        const totalStudents = scopedSections.reduce((sum, sec) => sum + num(sec.student_count), 0);
        const branchNames = Array.from(new Set(scopedSections.map((sec) => `${sec.branch_name ?? ""}`.trim()).filter(Boolean)));
        const sectionNames = Array.from(new Set(scopedSections.map((sec) => `${sec.section_name ?? ""}`.trim()).filter(Boolean)));
        const branchCount = new Set(scopedSections.map((sec) => sec.branch_id ?? sec.branch_name)).size;
        const sectionCount = scopedSections.length;
        // Show the actual name when a single branch/section is in scope; fall back to the count otherwise.
        const branchLabel = branchNames.length === 1 ? branchNames[0] : `${branchCount} Branch${branchCount > 1 ? "es" : ""}`;
        const sectionLabel = sectionNames.length === 1 ? sectionNames[0] : `${sectionCount} Section${sectionCount > 1 ? "s" : ""}`;
        const chipStyle = {
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "5px 12px",
            borderRadius: 9,
            background: "#f4f3ff",
            border: "1px solid #e7e3fb",
            color: "#5b4fd6",
            fontSize: 12.5,
            fontWeight: 600,
            whiteSpace: "nowrap",
        };

        return (
            <div
                className="mt-4"
                style={{
                    borderRadius: "16px",
                    border: "1px solid #ececf6",
                    background: "#ffffff",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.05)",
                    overflow: "hidden",
                }}
            >
                <div
                    className="d-flex align-items-center justify-content-between flex-wrap"
                    style={{ gap: 12, padding: "16px 20px", borderBottom: "1px solid #f1f2f5" }}
                >
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                        <div
                            className="d-inline-flex align-items-center justify-content-center text-white flex-shrink-0"
                            style={{
                                width: 42,
                                height: 42,
                                borderRadius: 12,
                                background: "linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)",
                                boxShadow: "0 6px 14px rgba(99,102,241,0.3)",
                            }}
                        >
                            <i className="fas fa-layer-group" style={{ fontSize: 17 }} />
                        </div>
                        <div>
                            <h6
                                className="font-weight-bold text-dark mb-0"
                                style={{ fontFamily: "'Outfit', sans-serif", fontSize: 16 }}
                            >
                                Batch-wise Average Score Comparison
                            </h6>
                            <span className="text-muted" style={{ fontSize: 12.5 }}>
                                Subject &amp; chapter accuracy across your class &amp; stream — filter by branch/section below
                            </span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
                        {branchOptions.length > 0 && (
                            <div style={{ minWidth: 180 }} className="batch-filter-select">
                                <MultiSelect
                                    options={branchOptions}
                                    value={branchSel}
                                    onChange={(v) => this.setState({ batchBranchSel: v, batchSectionSel: null })}
                                    labelledBy="Branches"
                                    hasSelectAll
                                    valueRenderer={(selected) =>
                                        selected.length === 0
                                            ? "Select Branches"
                                            : selected.length === branchOptions.length
                                                ? "All Branches"
                                                : `${selected.length} Branches selected`
                                    }
                                    overrideStrings={{
                                        allItemsAreSelected: "All Branches",
                                        selectSomeItems: "Select Branches",
                                        selectAll: "All Branches",
                                        search: "Search",
                                    }}
                                />
                            </div>
                        )}
                        {sectionOptions.length > 1 && (
                            <div style={{ minWidth: 200 }} className="batch-filter-select">
                                <MultiSelect
                                    options={sectionOptions}
                                    value={sectionSel}
                                    onChange={(v) => this.setState({ batchSectionSel: v })}
                                    labelledBy="Sections"
                                    hasSelectAll
                                    valueRenderer={(selected) =>
                                        selected.length === 0
                                            ? "Select Sections"
                                            : selected.length === sectionOptions.length
                                                ? "All Sections"
                                                : `${selected.length} Sections selected`
                                    }
                                    overrideStrings={{
                                        allItemsAreSelected: "All Sections",
                                        selectSomeItems: "Select Sections",
                                        selectAll: "All Sections",
                                        search: "Search",
                                    }}
                                />
                            </div>
                        )}
                        {streamSections.length > 0 && (
                            <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
                                {stream && (
                                    <span style={{ ...chipStyle, background: "#ede9fe", borderColor: "#ddd6fe", color: "#7c3aed" }}>
                                        <i className="fas fa-stream" style={{ fontSize: 11 }} /> {stream}
                                    </span>
                                )}
                                <span style={chipStyle}>
                                    <i className="fas fa-code-branch" style={{ fontSize: 11 }} /> {branchCount} Branch{branchCount > 1 ? "es" : ""}
                                </span>
                                <span style={chipStyle}>
                                    <i className="fas fa-users" style={{ fontSize: 11 }} /> {sectionCount} Section{sectionCount > 1 ? "s" : ""}
                                </span>
                                <span style={chipStyle}>
                                    <i className="fas fa-user-graduate" style={{ fontSize: 11 }} /> {totalStudents} Students
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                <div style={{ padding: "18px 20px" }}>
                    {/* Hide the batch graph when the STUDENT has no data for the
                        current filter (e.g. "Error Exam" but the student took none)
                        — otherwise the batch would show all-exam data misleadingly. */}
                    {(this.state.subjectPerformance || []).length === 0 ? (
                        <div className="d-flex flex-column align-items-center justify-content-center text-muted" style={{ minHeight: 240, fontSize: 14 }}>
                            <i className="fas fa-filter mb-2" style={{ fontSize: 26, color: "#cbd5e1" }} />
                            No exams for the selected filter — batch comparison isn't shown.
                        </div>
                    ) : scopedSections.length > 0 ? (
                        <>
                            <div style={{ borderRadius: 12, border: "1px solid #f1f2f5", background: "#fafaff", padding: "10px 12px" }}>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={options}
                                    containerProps={{ style: { width: "100%" } }}
                                />
                            </div>
                            <div className="mt-4">
                                <div className="d-flex align-items-center justify-content-between flex-wrap mb-3" style={{ gap: 10 }}>
                                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
                                        <p
                                            className="font-weight-bold text-dark mb-0"
                                            style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13.5, letterSpacing: "0.2px" }}
                                        >
                                            <i className={`fas ${batchView === "heatmap" ? "fa-th" : "fa-table"} mr-2`} style={{ color: "#7c3aed" }} />
                                            {batchView === "heatmap" ? "Accuracy Heatmap" : "Chapter-wise Accuracy"}
                                        </p>

                                        <div style={{ minWidth: 170 }} className="batch-filter-select">
                                            <SelectDropDown
                                                stateData={this.state.batchSubjectSel || subjectFilterOptions[0]}
                                                handleChange={(name, value, opt) => this.setState({ batchSubjectSel: opt })}
                                                name="batchSubjectSel"
                                                options={subjectFilterOptions}
                                                placeholderName="Subject"
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </div>

                                    </div>
                                    <div className="sp-segment">
                                        <button type="button" className={batchView === "table" ? "active" : ""} onClick={() => this.setState({ batchView: "table" })}>
                                            <i className="fas fa-table" />Table
                                        </button>
                                        <button type="button" className={batchView === "heatmap" ? "active" : ""} onClick={() => this.setState({ batchView: "heatmap" })}>
                                            <i className="fas fa-th" />Heatmap
                                        </button>
                                    </div>
                                </div>
                                {batchView === "heatmap" ? (
                                    this.renderBatchHeatmap(scopedSections, selectedSubject, isAllowedSubject)
                                ) : (
                                    <CardLessDataTableWithSearch
                                        parentData={tableRows}
                                        particlecolumns={this.batchChapterColumns}
                                        name="report"
                                    />
                                )}
                            </div>
                        </>
                    ) : (
                        <div
                            className="d-flex flex-column align-items-center justify-content-center text-muted"
                            style={{ minHeight: 360, fontSize: 14 }}
                        >
                            <i
                                className={`fas ${streamSections.length > 0 ? "fa-filter" : "fa-chart-column"} mb-2`}
                                style={{ fontSize: 26, color: "#cbd5e1" }}
                            />
                            {streamSections.length > 0
                                ? "Select at least one branch / section to view the comparison."
                                : "No batch comparison available."}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    // Risk level → color (High = red, Medium = amber, Low = green).
    riskColor = (level) => {
        const l = `${level || ""}`.toLowerCase();
        if (l.includes("high")) return "#dc2626";
        if (l.includes("medium") || l.includes("moderate")) return "#d97706";
        if (l.includes("low")) return "#16a34a";
        return "#1e293b";
    };

    // ── MOU #4: Attempt Rate — attempted vs skipped in each test ──────────────
    // Surfaced directly on Overview (not buried in the results modal). Per test:
    // Attempted (correct+wrong) vs Not Answered (skipped), plus attempt-rate %.
    // Graph and Table views.
    // Build one combined row per exam: attempt/skip + score/accuracy.
    buildExamPerformanceRows = () => {
        return (this.state.examWiseResult || [])
            .filter((e) => e.attempted && num(e.total_questions) > 0)
            .map((e) => {
                const correct = num(e.correct);
                const wrong = num(e.wrong);
                const total = num(e.total_questions);
                const attempted = correct + wrong;
                const notAnswered = Math.max(0, num(e.not_answered) || (total - attempted));
                const rate = total ? Math.round((attempted / total) * 100) : 0;
                return {
                    id: e.id,
                    exam_name: e.exam_name || e.date || "Exam",
                    date: e.date || "",
                    correct, wrong, attempted,
                    not_answered: notAnswered,
                    total,
                    rate,
                    score: num(e.marks),
                    accuracy: e.accuracy != null ? num(e.accuracy) : null,
                    // Section rank (rank 1 = section topper on that exam); section_total =
                    // how many in the section wrote it, so it renders as "#3 of 42".
                    section_rank: e.section_rank != null ? num(e.section_rank) : null,
                    section_total: e.section_total != null ? num(e.section_total) : null,
                    // "online" | "offline" from exam_paper.exam_mode (0 vs 1/2).
                    mode: e.mode === "offline" ? "offline" : "online",
                };
            })
            .reverse(); // chronological oldest → newest
    };

    // Section rank cell: "#3" badge + "of 42" so the standing is legible on its own.
    renderSectionRank = (r) => {
        const rank = r.section_rank;
        if (rank == null) return <span className="text-muted">-</span>;
        const total = r.section_total;
        const color = rank === 1 ? "#f59e0b" : rank === 2 ? "#94a3b8" : rank === 3 ? "#b45309" : "#6366f1";
        return (
            <div className="d-inline-flex flex-column align-items-end">
                <span
                    className="d-inline-flex align-items-center justify-content-center text-white font-weight-bold"
                    style={{ minWidth: 30, height: 24, padding: "0 8px", borderRadius: 7, background: color, fontSize: 12.5 }}
                    title={`Rank ${rank}${total ? ` of ${total}` : ""} in your class & section for this exam (highest score first)`}
                >
                    {rank === 1 ? <i className="fas fa-crown mr-1" style={{ fontSize: 10 }} /> : null}
                    #{rank}
                </span>
                {total ? <span className="text-muted" style={{ fontSize: 10.5, marginTop: 2 }}>of {total}</span> : null}
            </div>
        );
    };

    // Online/Offline pill next to an exam name. Only rendered when a student has
    // both modes (single-mode students don't need per-row labels).
    renderModeBadge = (mode) => {
        const offline = mode === "offline";
        return (
            <span
                className="d-inline-flex align-items-center font-weight-bold ml-2"
                style={{
                    fontSize: 10, padding: "1px 7px", borderRadius: 10, verticalAlign: "middle",
                    background: offline ? "#eef2ff" : "#ecfdf5",
                    color: offline ? "#4f46e5" : "#059669",
                    border: `1px solid ${offline ? "#c7d2fe" : "#a7f3d0"}`,
                }}
            >
                <i className={`fas ${offline ? "fa-file-lines" : "fa-wifi"} mr-1`} style={{ fontSize: 8 }} />
                {offline ? "Offline" : "Online"}
            </span>
        );
    };

    // ── MOU #4: Exam Performance — attempted vs skipped per test, COMBINED with
    // score/accuracy, with an exam-paper dropdown (All / single) and
    // graph + table views. Surfaced directly on Overview. Handles any # of exams.
    //
    // On-page shows only the LAST 5 (most recent) filtered exams so bars stay wide
    // and legible; a "View All (N)" button opens a popup with the full filtered set
    // (both graph and table). buildAttemptChartOptions / renderExamPerfTableRows are
    // shared by the on-page render and the popup so the two stay in lock-step.

    // Build Highcharts options for a given set of rows (5 on-page, all in popup).
    // Long exam names are truncated on the x-axis (full name in the tooltip); labels
    // stay horizontal for <=4 bars and rotate -35° at 5+ to avoid overlap.
    buildAttemptChartOptions = (rowsForChart) => {
        const chartRows = rowsForChart || [];
        // Categories carry the FULL exam name (so the tooltip header shows it in
        // full); the axis label formatter truncates the on-axis text with `trunc`.
        const categories = chartRows.map((r) => `${r.exam_name == null ? "" : r.exam_name}`);
        const maxTotal = chartRows.reduce((mx, r) => Math.max(mx, r.total), 0);
        return {
            chart: { type: "column", backgroundColor: "transparent", height: 340 },
            title: { text: "" },
            credits: { enabled: false },
            xAxis: {
                categories,
                lineColor: "#e2e8f0",
                labels: {
                    style: { color: "#64748b", fontWeight: "600", fontSize: "11px" },
                    rotation: chartRows.length > 4 ? -35 : 0,
                    // Truncate long names on the axis; full name stays in the tooltip.
                    formatter: function () { return trunc(this.value, 15); },
                },
            },
            yAxis: [
                {
                    min: 0, max: maxTotal || null, endOnTick: false, maxPadding: 0,
                    title: { text: "Questions", style: { color: "#94a3b8", fontSize: "11px" } },
                    gridLineColor: "#eef2f6", labels: { style: { color: "#64748b" } },
                },
                {
                    min: 0, max: 100, opposite: true, gridLineWidth: 0,
                    title: { text: "Attempt %", style: { color: "#22c55e", fontSize: "11px" } },
                    labels: { format: "{value}%", style: { color: "#22c55e" } },
                },
            ],
            // pointTooltip's card uses `this.key` (the category), which holds the
            // FULL exam name — so the tooltip shows it in full even though the axis
            // label is truncated.
            tooltip: pointTooltip({ unitBySeries: { "Attempt %": "%" } }),
            legend: { align: "center", verticalAlign: "top", itemStyle: { fontSize: "12px", fontWeight: "600" } },
            plotOptions: {
                column: {
                    stacking: "normal", borderRadius: 3, groupPadding: 0.15,
                    dataLabels: {
                        enabled: true,
                        // Hide labels for zero-height segments (a 0 stack label is
                        // what triggers the Highcharts hideOverlappingLabels crash).
                        formatter: function () { return this.y > 0 ? this.y : null; },
                        style: { fontWeight: "700", fontSize: "10px", color: "#fff", textOutline: "none" },
                    },
                },
                spline: { dataLabels: { enabled: true, formatter: function () { return this.y != null ? this.y + "%" : null; }, style: { fontWeight: "700", fontSize: "10px", color: "#16a34a", textOutline: "2px #fff" } } },
            },
            series: [
                { name: "Attempted", type: "column", yAxis: 0, data: chartRows.map((r) => r.attempted), color: "#22c55e" },
                { name: "Not Answered", type: "column", yAxis: 0, data: chartRows.map((r) => r.not_answered), color: "#f59e0b" },
                { name: "Attempt %", type: "spline", yAxis: 1, data: chartRows.map((r) => r.rate), color: "#16a34a", lineWidth: 3, marker: { enabled: true, radius: 4 } },
            ],
        };
    };

    // Table <tbody> rows for a given set. `withAggregate` adds the "All Exams (N)"
    // summary row up top (used only in the popup, where every exam is shown).
    // `showModeFilter` decides whether each row gets an online/offline badge.
    renderExamPerfTableRows = (rows, { withAggregate = false, showModeFilter = false } = {}) => {
        const list = rows || [];
        return (
            <>
                {withAggregate && list.length > 1 && (() => {
                    const agg = list.reduce((a, r) => ({
                        correct: a.correct + r.correct, wrong: a.wrong + r.wrong,
                        attempted: a.attempted + r.attempted, not_answered: a.not_answered + r.not_answered,
                        total: a.total + r.total, score: a.score + r.score,
                    }), { correct: 0, wrong: 0, attempted: 0, not_answered: 0, total: 0, score: 0 });
                    const aggRate = agg.total ? Math.round((agg.attempted / agg.total) * 100) : 0;
                    const aggAcc = agg.attempted ? Math.round((agg.correct / agg.attempted) * 100) : 0;
                    return (
                        <tr style={{ borderBottom: "2px solid #eef2f6", background: "#f8fafc" }}>
                            <td className="font-weight-bold text-dark" style={{ fontSize: 13 }}>All Exams ({list.length})</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#16a34a" }}>{agg.correct}</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#ef4444" }}>{agg.wrong}</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#16a34a" }}>{agg.attempted}</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#d97706" }}>{agg.not_answered}</td>
                            <td className="text-right font-weight-bold text-dark" style={{ fontSize: 13 }}>{agg.total}</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13, color: aggRate >= 90 ? "#16a34a" : aggRate >= 70 ? "#d97706" : "#dc2626" }}>{aggRate}%</td>
                            <td className="text-right font-weight-bold text-dark" style={{ fontSize: 13 }}>{agg.score}</td>
                            <td className="text-right font-weight-bold" style={{ fontSize: 13 }}>{aggAcc}%</td>
                            <td className="text-right text-muted" style={{ fontSize: 13 }}>—</td>
                            <td className="text-right text-muted" style={{ fontSize: 13 }}>—</td>
                        </tr>
                    );
                })()}
                {list.slice().reverse().map((r, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f6f8fb" }}>
                        <td style={{ fontSize: 13 }}>
                            <span className="font-weight-bold text-dark">{r.exam_name}</span>
                            {showModeFilter ? this.renderModeBadge(r.mode) : null}
                            {r.date ? <div className="text-muted" style={{ fontSize: 11 }}>{r.date}</div> : null}
                        </td>
                        <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#16a34a" }}>{r.correct}</td>
                        <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#ef4444" }}>{r.wrong}</td>
                        <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#16a34a" }}>{r.attempted}</td>
                        <td className="text-right font-weight-bold" style={{ fontSize: 13, color: "#d97706" }}>{r.not_answered}</td>
                        <td className="text-right text-muted" style={{ fontSize: 13 }}>{r.total}</td>
                        <td className="text-right font-weight-bold" style={{ fontSize: 13, color: r.rate >= 90 ? "#16a34a" : r.rate >= 70 ? "#d97706" : "#dc2626" }}>{r.rate}%</td>
                        <td className="text-right font-weight-bold text-dark" style={{ fontSize: 13 }}>{r.score}</td>
                        <td className="text-right" style={{ fontSize: 13 }}>{r.accuracy != null ? `${r.accuracy}%` : "-"}</td>
                        <td className="text-right" style={{ fontSize: 13 }}>{this.renderSectionRank(r)}</td>
                        <td className="text-right" style={{ fontSize: 13 }}>
                            <div className="d-inline-flex align-items-center" style={{ gap: 6 }}>
                                <button type="button" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center"
                                    style={{ width: 30, height: 30, borderRadius: 8, padding: 0 }}
                                    onClick={() => this.goToExamResult({ id: r.id, type: "schedule_exam" }, "schedule_exam")}
                                    title="View result analysis">
                                    <i className="fas fa-chart-line" style={{ fontSize: 12 }} />
                                </button>
                                <button type="button" className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center justify-content-center"
                                    style={{ width: 30, height: 30, borderRadius: 8, padding: 0 }}
                                    onClick={() => this.goToViewQA({ id: r.id, type: "schedule_exam" }, "schedule_exam")}
                                    title="View questions & answers">
                                    <i className="fas fa-external-link-alt" style={{ fontSize: 12 }} />
                                </button>
                            </div>
                        </td>
                    </tr>
                ))}
            </>
        );
    };

    // Shared table header row (identical on-page and in the popup).
    renderExamPerfTableHead = () => (
        <thead>
            <tr style={{ borderBottom: "1px solid #eef2f6" }}>
                <th className="text-muted" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Exam</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Correct</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Wrong</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Attempted</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Not Ans.</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Total</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Attempt %</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Score</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Accuracy</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }} title="Rank within your class & section in this institute">Section Rank</th>
                <th className="text-muted text-right" style={{ fontSize: 11, textTransform: "uppercase", fontWeight: 700 }}>Analysis</th>
            </tr>
        </thead>
    );

    renderExamPerformance = () => {
        const allRows = this.buildExamPerformanceRows();
        // Exam dropdown options (All + each distinct exam).
        const examOptions = [
            { value: 0, label: "All exams" },
            ...allRows.map((r) => ({ value: r.id, label: r.exam_name })),
        ];
        const sel = this.state.attemptExamSel || examOptions[0];
        const isAll = !sel.value;
        // Online/Offline segmentation. Only show the filter when the student
        // actually has BOTH modes — a single-mode student sees no clutter, and it
        // scales automatically as clients add online exams.
        const hasOnline = allRows.some((r) => r.mode === "online");
        const hasOffline = allRows.some((r) => r.mode === "offline");
        const showModeFilter = hasOnline && hasOffline;
        const modeSel = showModeFilter ? (this.state.attemptModeSel || "all") : "all";
        const modeFiltered = modeSel === "all" ? allRows : allRows.filter((r) => r.mode === modeSel);
        // `filtered` = the full filtered set (mode + exam-paper filters applied). Rows
        // are oldest→newest, so the on-page view takes the LAST 5 (most recent).
        const filtered = isAll ? modeFiltered : modeFiltered.filter((r) => r.id === sel.value);
        const shown = filtered.slice(-5);
        const hasMore = filtered.length > 5; // → show "View All (N)"

        const view = this.state.attemptView;
        const options = this.buildAttemptChartOptions(shown);

        return (
            <div className="p-3 h-100" style={{ borderRadius: "16px", border: "1px solid #f1f2f5", background: "#ffffff" }}>
                <div className="d-flex align-items-start justify-content-between flex-wrap mb-3" style={{ gap: 10 }}>
                    <div>
                        <h6 className="font-weight-bold text-dark mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>
                            <i className="fas fa-list-check mr-2" style={{ color: "#7c3aed" }} />
                            Exam Performance — attempted vs skipped &amp; score
                        </h6>
                        <span className="text-muted" style={{ fontSize: "11.5px" }}>
                            <span style={{ color: "#22c55e" }}>Attempted</span> = answered · <span style={{ color: "#f59e0b" }}>Not Answered</span> = left blank
                            {hasMore ? <> · showing latest 5 of {filtered.length}</> : null}
                        </span>
                    </div>
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 10 }}>
                        {/* Online/Offline filter — appears only when the student has both. */}
                        {showModeFilter && (
                            <div className="sp-segment sp-segment-sm">
                                <button type="button" className={modeSel === "all" ? "active" : ""} onClick={() => this.setState({ attemptModeSel: "all" })}>
                                    All
                                </button>
                                <button type="button" className={modeSel === "online" ? "active" : ""} onClick={() => this.setState({ attemptModeSel: "online" })}>
                                    <i className="fas fa-wifi" />Online
                                </button>
                                <button type="button" className={modeSel === "offline" ? "active" : ""} onClick={() => this.setState({ attemptModeSel: "offline" })}>
                                    <i className="fas fa-file-lines" />Offline
                                </button>
                            </div>
                        )}
                        {/* Exam-paper dropdown lives in the tab header now (top). */}
                        {shown.length > 0 && (
                            <div className="sp-segment sp-segment-sm">
                                <button type="button" className={view === "graph" ? "active" : ""} onClick={() => this.setState({ attemptView: "graph" })}>
                                    <i className="fas fa-chart-column" />Graph
                                </button>
                                <button type="button" className={view === "table" ? "active" : ""} onClick={() => this.setState({ attemptView: "table" })}>
                                    <i className="fas fa-table" />Table
                                </button>
                            </div>
                        )}
                        {/* View All — only when there are more than 5 filtered exams. */}
                        {hasMore && (
                            <button
                                type="button"
                                className="btn btn-sm d-inline-flex align-items-center font-weight-bold"
                                style={{ borderRadius: 8, background: "#f4f0fe", color: "#7c3aed", border: "1px solid #e4d9fb", fontSize: 12.5, padding: "5px 12px" }}
                                onClick={() => this.setState({ examPerfModalOpen: true })}
                                title="See all exams"
                            >
                                <i className="fas fa-up-right-and-down-left-from-center mr-2" style={{ fontSize: 11 }} />
                                View All ({filtered.length})
                            </button>
                        )}
                    </div>
                </div>

                {shown.length === 0 ? (
                    <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>No attempted exams yet.</div>
                ) : view === "graph" ? (
                    // Capped at 5 on-page, so bars stay wide. Still allow a little
                    // horizontal scroll on very narrow viewports.
                    <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                        <div style={{ minWidth: Math.max(shown.length * 80, 320) }}>
                            <HighchartsReact highcharts={Highcharts} options={options} containerProps={{ style: { width: "100%" } }} />
                        </div>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-borderless mb-0">
                            {this.renderExamPerfTableHead()}
                            <tbody>
                                {/* On-page table: last 5 only, NO aggregate row. */}
                                {this.renderExamPerfTableRows(shown, { withAggregate: false, showModeFilter })}
                            </tbody>
                        </table>
                    </div>
                )}

                {this.renderExamPerfModal(filtered, showModeFilter)}
            </div>
        );
    };

    // "View All" popup — every filtered exam, with its own graph/table toggle. The
    // body scrolls; the graph scrolls horizontally (~80px/bar) when there are many.
    renderExamPerfModal = (filtered, showModeFilter) => {
        if (!this.state.examPerfModalOpen) return null;
        const rows = filtered || [];
        const view = this.state.examPerfModalView || "table";
        const options = this.buildAttemptChartOptions(rows);
        return (
            <Modal show onHide={() => this.setState({ examPerfModalOpen: false })} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontFamily: "'Outfit', sans-serif", fontSize: "17px" }}>
                        <i className="fas fa-list-check mr-2" style={{ color: "#7c3aed" }} />
                        All Exams ({rows.length})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "72vh", overflowY: "auto" }}>
                    <div className="d-flex justify-content-end mb-3">
                        <div className="sp-segment sp-segment-sm">
                            <button type="button" className={view === "graph" ? "active" : ""} onClick={() => this.setState({ examPerfModalView: "graph" })}>
                                <i className="fas fa-chart-column" />Graph
                            </button>
                            <button type="button" className={view === "table" ? "active" : ""} onClick={() => this.setState({ examPerfModalView: "table" })}>
                                <i className="fas fa-table" />Table
                            </button>
                        </div>
                    </div>
                    {rows.length === 0 ? (
                        <div className="text-center text-muted py-4" style={{ fontSize: 14 }}>No attempted exams yet.</div>
                    ) : view === "graph" ? (
                        <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                            <div style={{ minWidth: Math.max(rows.length * 80, 320) }}>
                                <HighchartsReact highcharts={Highcharts} options={options} containerProps={{ style: { width: "100%" } }} />
                            </div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-borderless mb-0">
                                {this.renderExamPerfTableHead()}
                                <tbody>
                                    {/* Popup table: ALL rows, WITH the aggregate summary row. */}
                                    {this.renderExamPerfTableRows(rows, { withAggregate: true, showModeFilter })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    };

    // The exam the header Exam-Paper dropdown has selected (0 / null = All).
    // Returns the matching examWiseResult row so every section can scope to it.
    getSelectedExam = () => {
        const sel = this.state.attemptExamSel;
        if (!sel || !sel.value) return null; // All exams
        return (this.state.examWiseResult || []).find((e) => e.id === sel.value) || null;
    };

    render() {
        const { overallData, subjectPerformance, snapshot, batchComparison, loading } = this.state;

        // When a single exam is selected in the header, scope the WHOLE tab to it:
        // summary cards, trend chart and snapshot all reflect that one exam. When
        // "All exams" is selected, use the full backend datasets as-is.
        const selectedExam = this.getSelectedExam();
        const isSingle = !!selectedExam;

        // Filtered exam-subject matrix (single exam → just that paper's row).
        const filteredMatrix = isSingle
            ? (this.state.examSubjectMatrix || []).filter(
                (m) => m.exam_name === selectedExam.exam_name || String(m.session_id) === String(selectedExam.id))
            : (this.state.examSubjectMatrix || []);

        // Cards + trend read from these; when single, build a one-row "overall".
        const scopedOverall = isSingle
            ? [{
                exam_name: selectedExam.exam_name,
                total_attempt_test: 1,
                average_score: num(selectedExam.marks),
                highest_score: num(selectedExam.marks),
                lowest_score: num(selectedExam.marks),
                section_avg_score: 0,
                branch_avg_score: 0,
                accuracy: selectedExam.accuracy != null ? num(selectedExam.accuracy) : 0,
            }]
            : overallData;

        // Exam results in scope for the summary cards: every exam the report returned,
        // or just the selected one.
        const scopedExams = isSingle ? [selectedExam] : (this.state.examWiseResult || []).filter(isScheduledExam);

        return (
            <TabSection
                icon="fa-eye"
                title="Overview"
                description="Consolidated snapshot of the student's exam performance."
                headerRight={this.renderControls()}
            >
                {loading ? (
                    <PageShimmer />
                ) : (
                    <Row>
                        {/* Filter banner when a single exam is scoped. */}
                        {isSingle && (
                            <Col sm={12} className="mb-2">
                                <div className="d-flex align-items-center justify-content-between flex-wrap px-3 py-2" style={{ gap: 8, background: "#f4f0fe", borderRadius: 10 }}>
                                    <span style={{ fontSize: 13, fontWeight: 600, color: "#4b3a72" }}>
                                        <i className="fas fa-filter mr-2" />Showing: <b>{selectedExam.exam_name}</b>
                                    </span>
                                    <button type="button" className="btn btn-sm btn-link p-0" style={{ fontSize: 12, color: "#7c3aed", fontWeight: 700 }}
                                        onClick={() => this.setState({ attemptExamSel: { value: 0, label: "All exams" } })}>
                                        Clear — show all exams
                                    </button>
                                </div>
                            </Col>
                        )}

                        <Col sm={12}><ChartBoundary resetKey={this.state.attemptExamSel} label="Summary unavailable for this selection.">{this.renderSummaryCards(scopedOverall, filteredMatrix, scopedExams)}</ChartBoundary></Col>

                        {/* Trend is inherently multi-exam (score movement across
                            tests), so it ALWAYS uses the full data — a single-exam
                            filter would collapse it to one meaningless point. */}
                        <Col sm={6}><ChartBoundary resetKey={this.state.attemptExamSel} label="Trend chart unavailable.">{this.renderTrendChart(overallData, selectedExam)}</ChartBoundary></Col>

                        <Col sm={6}><ChartBoundary label="Snapshot unavailable.">{this.renderSnapshot(snapshot)}</ChartBoundary></Col>

                        {/* MOU #4 — Exam Performance: attempted vs skipped + score
                            per exam. Combines the old summary table + attempt data,
                            controlled by the header Exam-Paper dropdown. Graph/table. */}
                        <Col sm={12}>
                            <div className="mt-4"><ChartBoundary resetKey={this.state.attemptExamSel} label="Exam performance unavailable.">{this.renderExamPerformance()}</ChartBoundary></div>
                        </Col>

                        {/* Exam History table commented out — its row actions now live in
                            the Schedule Exam "Exam-wise Results" modal (modalColumns). */}
                        {/* <Col sm={12}>{this.renderExamHistoryTable()}</Col> */}

                        <Col sm={12}>
                            {this.state.batchLoading ? (
                                this.renderBatchLoading()
                            ) : (
                                <ChartBoundary resetKey={this.state.attemptExamSel} label="Batch comparison unavailable.">{this.renderBatchComparison(batchComparison)}</ChartBoundary>
                            )}
                        </Col>
                    </Row>
                )}
                {this.renderExamModal()}
                {this.renderBatchDetailModal()}
                {this.renderChapterTopicModal()}
                {this.renderSubjectMatrixModal()}
                {this.renderSummaryModal()}
                {this.renderTopStudentsDrawer()}
            </TabSection>
        );
    }
}

export default compose(withApollo, withRouter)(OverviewTab);
